interface Icon {
  label: string;
  icon: any;
}


export const company: Icon = {
  label: "company",
  icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 22H5C3 22 2 21 2 19V11C2 9 3 8 5 8H10V19C10 21 11 22 13 22Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.11 4C10.03 4.3 10 4.63 10 5V8H5V6C5 4.9 5.9 4 7 4H10.11Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 8V13"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 8V13"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 17H15C14.45 17 14 17.45 14 18V22H18V18C18 17.45 17.55 17 17 17Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 13V17"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 19V5C10 3 11 2 13 2H19C21 2 22 3 22 5V19C22 21 21 22 19 22H13C11 22 10 21 10 19Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const convert: Icon = {
  label: "convert",
  icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 17.98L5.54999 17.99C6.45999 17.99 7.31 17.54 7.81 16.79L14.2 7.21C14.7 6.46 15.55 5.99999 16.46 6.00999L21.01 6.03001"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 19.98L21 17.98"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.89001 8.61999L7.81 7.11999C7.3 6.40999 6.47999 5.98999 5.60999 5.99999L3 6.01"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.97 15.38L14.19 16.95C14.7 17.61 15.5 18 16.34 18L21.01 17.98"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 6.02002L19 4.02002"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const connection: Icon = {
  label: "connection",
  icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 14C21.1046 14 22 13.1046 22 12C22 10.8954 21.1046 10 20 10C18.8954 10 18 10.8954 18 12C18 13.1046 18.8954 14 20 14Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20 6C21.1046 6 22 5.10457 22 4C22 2.89543 21.1046 2 20 2C18.8954 2 18 2.89543 18 4C18 5.10457 18.8954 6 20 6Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20 22C21.1046 22 22 21.1046 22 20C22 18.8954 21.1046 18 20 18C18.8954 18 18 18.8954 18 20C18 21.1046 18.8954 22 20 22Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 14C5.10457 14 6 13.1046 6 12C6 10.8954 5.10457 10 4 10C2.89543 10 2 10.8954 2 12C2 13.1046 2.89543 14 4 14Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 12H18"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 4H14C12 4 11 5 11 7V17C11 19 12 20 14 20H18"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const user: Icon = {
  label: "user",
  icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.5901 22C20.5901 18.13 16.7402 15 12.0002 15C7.26015 15 3.41016 18.13 3.41016 22"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const users: Icon = {
  label: "users",
  icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.15957 10.87C9.05957 10.86 8.93957 10.86 8.82957 10.87C6.44957 10.79 4.55957 8.84 4.55957 6.44C4.55957 3.99 6.53957 2 8.99957 2C11.4496 2 13.4396 3.99 13.4396 6.44C13.4296 8.84 11.5396 10.79 9.15957 10.87Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4103 4C18.3503 4 19.9103 5.57 19.9103 7.5C19.9103 9.39 18.4103 10.93 16.5403 11C16.4603 10.99 16.3703 10.99 16.2803 11"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.15973 14.56C1.73973 16.18 1.73973 18.82 4.15973 20.43C6.90973 22.27 11.4197 22.27 14.1697 20.43C16.5897 18.81 16.5897 16.17 14.1697 14.56C11.4297 12.73 6.91973 12.73 4.15973 14.56Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3398 20C19.0598 19.85 19.7398 19.56 20.2998 19.13C21.8598 17.96 21.8598 16.03 20.2998 14.86C19.7498 14.44 19.0798 14.16 18.3698 14"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const role: Icon = {
  label: "role",
  icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9999 11C13.2867 11 14.3299 9.95681 14.3299 8.66998C14.3299 7.38316 13.2867 6.34003 11.9999 6.34003C10.7131 6.34003 9.66992 7.38316 9.66992 8.66998C9.66992 9.95681 10.7131 11 11.9999 11Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 16.66C16 14.86 14.21 13.4 12 13.4C9.79 13.4 8 14.86 8 16.66"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const email: Icon = {
  label: "email",
  icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5H7"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 16.5H8"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 12.5H5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const balanceSheet: Icon = {
  label: "balanceSheet",
  icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 2H16L20 6V22H4V2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 2V6H20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="8"
        y1="10"
        x2="16"
        y2="10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="8"
        y1="14"
        x2="16"
        y2="14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="8"
        y1="18"
        x2="12"
        y2="18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
};


export const tenant: Icon = {
  label: "tenant",
  icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5007 22.0003H4.0807C2.9207 22.0003 1.9707 21.0703 1.9707 19.9303V5.09035C1.9707 2.47035 3.9207 1.28035 6.3107 2.45035L10.7507 4.63035C11.7107 5.10035 12.5007 6.35035 12.5007 7.41035V22.0003Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.97 15.0602V18.8402C21.97 21.0002 20.97 22.0002 18.81 22.0002H12.5V10.4202L12.97 10.5202L17.47 11.5302L19.5 11.9802C20.82 12.2702 21.9 12.9502 21.96 14.8702C21.97 14.9302 21.97 14.9902 21.97 15.0602Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.5 9.00012H8.97"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.5 13.0001H8.97"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.4707 11.53V14.75C17.4707 15.99 16.4607 17 15.2207 17C13.9807 17 12.9707 15.99 12.9707 14.75V10.52L17.4707 11.53Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.9607 14.8703C21.9007 16.0503 20.9207 17.0003 19.7207 17.0003C18.4807 17.0003 17.4707 15.9903 17.4707 14.7503V11.5303L19.5007 11.9803C20.8207 12.2703 21.9007 12.9503 21.9607 14.8703Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const hamburgerMenu: Icon = {
  label: "hamburger-menu",
  icon: (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1H15"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M1 6H11"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M1 11H15"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  ),
};

export const home: Icon = {
  label: "home",
  icon: (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 8.75961C1 7.40185 1 6.72297 1.27446 6.12623C1.54892 5.52949 2.06437 5.08769 3.09525 4.20407L4.09525 3.34693C5.95857 1.7498 6.89023 0.951233 8 0.951233C9.10977 0.951233 10.0414 1.7498 11.9047 3.34693L12.9047 4.20407C13.9356 5.08769 14.4511 5.52949 14.7255 6.12623C15 6.72297 15 7.40185 15 8.75961V13C15 14.8856 15 15.8284 14.4142 16.4142C13.8284 17 12.8856 17 11 17H5C3.11438 17 2.17157 17 1.58579 16.4142C1 15.8284 1 14.8856 1 13V8.75961Z"
        stroke="currentColor"
      />
      <path
        d="M10.5 17V12C10.5 11.4477 10.0523 11 9.5 11H6.5C5.94772 11 5.5 11.4477 5.5 12V17"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const logout: Icon = {
  label: "logout",
  icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.8999 7.56C9.2099 3.96 11.0599 2.49 15.1099 2.49H15.2399C19.7099 2.49 21.4999 4.28 21.4999 8.75V15.27C21.4999 19.74 19.7099 21.53 15.2399 21.53H15.1099C11.0899 21.53 9.2399 20.08 8.9099 16.54"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.0001 12H3.62012"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.85 8.65L2.5 12L5.85 15.35"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const setting: Icon = {
  label: "setting",
  icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 6.5H16"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 6.5H2"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 10C11.933 10 13.5 8.433 13.5 6.5C13.5 4.567 11.933 3 10 3C8.067 3 6.5 4.567 6.5 6.5C6.5 8.433 8.067 10 10 10Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22 17.5H18"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 17.5H2"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 21C15.933 21 17.5 19.433 17.5 17.5C17.5 15.567 15.933 14 14 14C12.067 14 10.5 15.567 10.5 17.5C10.5 19.433 12.067 21 14 21Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const profile: Icon = {
  label: "profile",
  icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1197 12.78C12.0497 12.77 11.9597 12.77 11.8797 12.78C10.1197 12.72 8.71973 11.28 8.71973 9.50998C8.71973 7.69998 10.1797 6.22998 11.9997 6.22998C13.8097 6.22998 15.2797 7.69998 15.2797 9.50998C15.2697 11.28 13.8797 12.72 12.1197 12.78Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.7398 19.38C16.9598 21.01 14.5998 22 11.9998 22C9.39977 22 7.03977 21.01 5.25977 19.38C5.35977 18.44 5.95977 17.52 7.02977 16.8C9.76977 14.98 14.2498 14.98 16.9698 16.8C18.0398 17.52 18.6398 18.44 18.7398 19.38Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const arrowRight: Icon = {
  label: "arrowRight",
  icon: (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4299 0.929993L18.4999 6.99999L12.4299 13.07" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /><path d="M1.5 7H18.33" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /></svg>
  ),
};

export const longarrowRight: Icon = {
  label: "longarrowRight",
  icon: (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4299 0.929993L18.4999 6.99999L12.4299 13.07"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.5 7H18.33"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const longarrowLeft: Icon = {
  label: "longarrowLeft",
  icon: (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.57 0.929993L1.5 6.99999L7.57 13.07"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.4999 7H1.66992"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const profileDuotone: Icon = {
  label: "profileDuotone",
  icon: (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M12 22.01C17.5228 22.01 22 17.5329 22 12.01C22 6.48716 17.5228 2.01001 12 2.01001C6.47715 2.01001 2 6.48716 2 12.01C2 17.5329 6.47715 22.01 12 22.01Z"
        fill="currentColor"
      />
      <path
        d="M12 6.93994C9.93 6.93994 8.25 8.61994 8.25 10.6899C8.25 12.7199 9.84 14.3699 11.95 14.4299C11.98 14.4299 12.02 14.4299 12.04 14.4299C12.06 14.4299 12.09 14.4299 12.11 14.4299C12.12 14.4299 12.13 14.4299 12.13 14.4299C14.15 14.3599 15.74 12.7199 15.75 10.6899C15.75 8.61994 14.07 6.93994 12 6.93994Z"
        fill="currentColor"
      />
      <path
        d="M18.7807 19.36C17.0007 21 14.6207 22.01 12.0007 22.01C9.3807 22.01 7.0007 21 5.2207 19.36C5.4607 18.45 6.1107 17.62 7.0607 16.98C9.7907 15.16 14.2307 15.16 16.9407 16.98C17.9007 17.62 18.5407 18.45 18.7807 19.36Z"
        fill="currentColor"
      />
    </svg>
  ),
};

export const settingDuotone: Icon = {
  label: "settingDuotone",
  icon: (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M2 12.8799V11.1199C2 10.0799 2.85 9.21994 3.9 9.21994C5.71 9.21994 6.45 7.93994 5.54 6.36994C5.02 5.46994 5.33 4.29994 6.24 3.77994L7.97 2.78994C8.76 2.31994 9.78 2.59994 10.25 3.38994L10.36 3.57994C11.26 5.14994 12.74 5.14994 13.65 3.57994L13.76 3.38994C14.23 2.59994 15.25 2.31994 16.04 2.78994L17.77 3.77994C18.68 4.29994 18.99 5.46994 18.47 6.36994C17.56 7.93994 18.3 9.21994 20.11 9.21994C21.15 9.21994 22.01 10.0699 22.01 11.1199V12.8799C22.01 13.9199 21.16 14.7799 20.11 14.7799C18.3 14.7799 17.56 16.0599 18.47 17.6299C18.99 18.5399 18.68 19.6999 17.77 20.2199L16.04 21.2099C15.25 21.6799 14.23 21.3999 13.76 20.6099L13.65 20.4199C12.75 18.8499 11.27 18.8499 10.36 20.4199L10.25 20.6099C9.78 21.3999 8.76 21.6799 7.97 21.2099L6.24 20.2199C5.33 19.6999 5.02 18.5299 5.54 17.6299C6.45 16.0599 5.71 14.7799 3.9 14.7799C2.85 14.7799 2 13.9199 2 12.8799Z"
        fill="currentColor"
      />
      <path
        d="M12 15.25C13.7949 15.25 15.25 13.7949 15.25 12C15.25 10.2051 13.7949 8.75 12 8.75C10.2051 8.75 8.75 10.2051 8.75 12C8.75 13.7949 10.2051 15.25 12 15.25Z"
        fill="currentColor"
      />
    </svg>
  ),
};

export const logoutDuotone: Icon = {
  label: "logoutDuotone",
  icon: (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        d="M15.9998 2L14.9998 2C12.1714 2 10.7576 2.00023 9.87891 2.87891C9.00023 3.75759 9.00023 5.1718 9.00023 8.00023L9.00023 16.0002C9.00023 18.8287 9.00023 20.2429 9.87891 21.1215C10.7574 22 12.1706 22 14.9976 22L14.9998 22L15.9998 22C18.8282 22 20.2424 22 21.1211 21.1213C21.9998 20.2426 21.9998 18.8284 21.9998 16L21.9998 8L21.9998 7.99998C21.9998 5.17157 21.9998 3.75736 21.1211 2.87868C20.2424 2 18.8282 2 15.9998 2Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.75 12C15.75 11.5858 15.4142 11.25 15 11.25L4.02744 11.25L5.98809 9.56943C6.30259 9.29986 6.33901 8.82639 6.06944 8.51189C5.79988 8.1974 5.3264 8.16098 5.01191 8.43054L1.51191 11.4305C1.34567 11.573 1.25 11.781 1.25 12C1.25 12.2189 1.34567 12.4269 1.51191 12.5694L5.01191 15.5694C5.3264 15.839 5.79988 15.8026 6.06944 15.4881C6.33901 15.1736 6.30259 14.7001 5.98809 14.4305L4.02744 12.75L15 12.75C15.4142 12.75 15.75 12.4142 15.75 12Z"
        fill="currentColor"
      />
    </svg>
  ),
};

export const edit: Icon = {
  label: "editIcon",
  icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2603 3.60022L5.05034 12.2902C4.74034 12.6202 4.44034 13.2702 4.38034 13.7202L4.01034 16.9602C3.88034 18.1302 4.72034 18.9302 5.88034 18.7302L9.10034 18.1802C9.55034 18.1002 10.1803 17.7702 10.4903 17.4302L18.7003 8.74022C20.1203 7.24022 20.7603 5.53022 18.5503 3.44022C16.3503 1.37022 14.6803 2.10022 13.2603 3.60022Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8896 5.0498C12.3196 7.8098 14.5596 9.9198 17.3396 10.1998"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 22H21"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const editSolid: Icon = {
  label: "editSolid",
  icon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.204 7.79601L16 6C16.5453 5.45475 16.8179 5.18213 16.9636 4.88803C17.2409 4.32848 17.2409 3.67153 16.9636 3.11197C16.8179 2.81788 16.5453 2.54525 16 2C15.4548 1.45475 15.1821 1.18213 14.888 1.03639C14.3285 0.75911 13.6715 0.75911 13.112 1.03639C12.8179 1.18213 12.5453 1.45475 12 2L10.1814 3.81866C11.1452 5.46926 12.5314 6.84482 14.204 7.79601ZM8.7269 5.27312L1.8564 12.1436C1.43134 12.5687 1.21881 12.7812 1.07907 13.0423C0.939336 13.3034 0.88039 13.5981 0.7625 14.1876L0.147104 17.2646C0.0805817 17.5972 0.0473206 17.7635 0.141929 17.8581C0.236537 17.9527 0.402842 17.9194 0.735452 17.8529L3.81243 17.2375C4.40189 17.1196 4.69661 17.0607 4.95771 16.9209C5.21881 16.7812 5.43134 16.5687 5.8564 16.1436L12.7458 9.25422C11.1241 8.23857 9.75244 6.87628 8.7269 5.27312Z"
        fill="currentColor"
      />
    </svg>
  ),
};

export const plus: Icon = {
  label: "plus",
  icon: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 7H13"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 13V1"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const arrowLeft: Icon = {
  label: "arrowLeft",
  icon: (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.57 0.929993L1.5 6.99999L7.57 13.07"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.4999 7H1.66992"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const leftArrow: Icon = {
  label: "leftArrow",
  icon: (
    <svg
      width="9"
      height="18"
      viewBox="0 0 9 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00009 16.92L1.48009 10.4C0.710088 9.62999 0.710088 8.36999 1.48009 7.59999L8.00009 1.07999"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const doubleleftArrow: Icon = {
  label: "doubleleftArrow",
  icon: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00009 16.92L1.48009 10.4C0.710088 9.62999 0.710088 8.36999 1.48009 7.59999L8.00009 1.07999"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.0001 16.92L9.48009 10.4C8.71009 9.62999 8.71009 8.36999 9.48009 7.59999L16.0001 1.07999"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const rightArrow: Icon = {
  label: "rightArrow",
  icon: (
    <svg
      width="9"
      height="18"
      viewBox="0 0 9 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.909912 16.92L7.42991 10.4C8.19991 9.62999 8.19991 8.36999 7.42991 7.59999L0.909912 1.07999"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const doublerightArrow: Icon = {
  label: "doublerightArrow",
  icon: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.90991 16.92L15.4299 10.4C16.1999 9.62999 16.1999 8.36999 15.4299 7.59999L8.90991 1.07999"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.909912 16.92L7.42991 10.4C8.19991 9.62999 8.19991 8.36999 7.42991 7.59999L0.909912 1.07999"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const deleteIcon: Icon = {
  label: "deleteIcon",
  icon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5001 4H1.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M7.5 9L8 14"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M12.5 9L12 14"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M4.5 4C4.55588 4 4.58382 4 4.60915 3.99936C5.43259 3.97849 6.15902 3.45491 6.43922 2.68032C6.44784 2.65649 6.45667 2.62999 6.47434 2.57697L6.57143 2.28571C6.65431 2.03708 6.69575 1.91276 6.75071 1.8072C6.97001 1.38607 7.37574 1.09364 7.84461 1.01877C7.96213 1 8.09317 1 8.35526 1H11.6447C11.9068 1 12.0379 1 12.1554 1.01877C12.6243 1.09364 13.03 1.38607 13.2493 1.8072C13.3043 1.91276 13.3457 2.03708 13.4286 2.28571L13.5257 2.57697C13.5433 2.62992 13.5522 2.65651 13.5608 2.68032C13.841 3.45491 14.5674 3.97849 15.3909 3.99936C15.4162 4 15.4441 4 15.5 4"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <path
        d="M16.3735 13.3991C16.1965 16.054 16.108 17.3815 15.243 18.1907C14.378 19 13.0476 19 10.3868 19H9.6134C6.9526 19 5.6222 19 4.75719 18.1907C3.89218 17.3815 3.80368 16.054 3.62669 13.3991L3.16675 6.5M16.8334 6.5L16.2974 14.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  ),
};

export const briefcase: Icon = {
  label: "briefcase",
  icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99983 22H15.9998C20.0198 22 20.7398 20.39 20.9498 18.43L21.6998 10.43C21.9698 7.99 21.2698 6 16.9998 6H6.99983C2.72983 6 2.02983 7.99 2.29983 10.43L3.04983 18.43C3.25983 20.39 3.97983 22 7.99983 22Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 6V5.2C8 3.43 8 2 11.2 2H12.8C16 2 16 3.43 16 5.2V6"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 13V14C14 14.01 14 14.01 14 14.02C14 15.11 13.99 16 12 16C10.02 16 10 15.12 10 14.03V13C10 12 10 12 11 12H13C14 12 14 12 14 13Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.65 11C19.34 12.68 16.7 13.68 14 14.02"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.62012 11.27C4.87012 12.81 7.41012 13.74 10.0001 14.03"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const clock: Icon = {
  label: "clock",
  icon: (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="10" stroke="currentColor" stroke-width="1.5" /><path d="M11 7V11L13.5 13.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
  ),
};

export const xero: Icon = {
  label: "xero",
  icon: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-23C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1z" /><path d="M19.263 14.5c-1.509 0-2.736-1.233-2.736-2.75S17.754 9 19.263 9C20.772 9 22 10.233 22 11.75s-1.228 2.75-2.737 2.75zm0-4.5c-.957 0-1.736.785-1.736 1.75s.779 1.75 1.736 1.75c.958 0 1.737-.785 1.737-1.75S20.221 10 19.263 10zM2.5 14.5a.5.5 0 0 1-.355-.853l4.474-4.5a.5.5 0 1 1 .709.706l-4.474 4.5a.496.496 0 0 1-.354.147z" /><path d="M6.974 14.5a.496.496 0 0 1-.354-.147l-4.474-4.5a.5.5 0 1 1 .708-.706l4.474 4.5a.5.5 0 0 1-.354.853zm3.184 0c-1.51 0-2.737-1.233-2.737-2.75S8.648 9 10.158 9a2.745 2.745 0 0 1 2.736 2.75.5.5 0 0 1-.5.5H8.493c.214.722.88 1.25 1.665 1.25.431 0 1.061-.083 1.552-.806a.499.499 0 1 1 .826.562c-.56.826-1.36 1.244-2.378 1.244zm-1.665-3.25h3.329c-.214-.722-.879-1.25-1.664-1.25s-1.451.528-1.665 1.25zm6.02 3.25a.5.5 0 0 1-.5-.5V9.5a.5.5 0 0 1 1 0V14a.5.5 0 0 1-.5.5z" /><path d="M14.513 11.35a.5.5 0 0 1-.5-.5c0-.936.896-1.82 1.843-1.82a.5.5 0 0 1 0 1c-.426 0-.843.47-.843.82a.5.5 0 0 1-.5.5zm4.75 1.35a.95.95 0 0 1 0-1.9.95.95 0 0 1 0 1.9zm-.052-.95c0 .028.022.05.052.05l-.052-.05z" /></svg>
  ),
};
export const qboLogo: Icon = {
  label: "qbo",
  icon: (
    <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M30.77 61.54C47.76 61.54 61.54 47.76 61.54 30.77C61.54 13.78 47.76 0 30.77 0C13.78 0 0 13.78 0 30.77C0 47.76 13.77 61.54 30.77 61.54Z" fill="#2CA01C" />
      <path d="M20.51 18.8C13.9 18.8 8.54004 24.16 8.54004 30.77C8.54004 37.38 13.89 42.73 20.51 42.73H22.22V38.29H20.51C16.36 38.29 12.99 34.92 12.99 30.77C12.99 26.62 16.36 23.25 20.51 23.25H24.62V46.5C24.62 48.95 26.61 50.94 29.06 50.94V18.8H20.51ZM41.03 42.73C47.64 42.73 53 37.37 53 30.77C53 24.17 47.65 18.81 41.03 18.81H39.32V23.25H41.03C45.18 23.25 48.55 26.62 48.55 30.77C48.55 34.92 45.18 38.29 41.03 38.29H36.92V15.04C36.92 12.59 34.93 10.6 32.48 10.6V42.73H41.03Z" fill="white" />
    </svg>
  ),
};
export const qboButton: Icon = {
  label: "qbobutton",
  icon: (
    <svg width="161" height="36" viewBox="0 0 161 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 4C0 1.79086 1.79086 0 4 0H157C159.209 0 161 1.79086 161 4V32C161 34.2091 159.209 36 157 36H4C1.79086 36 0 34.2091 0 32V4Z" fill="#0077C5" />
      <path d="M24.4844 13.6C23.6204 12.784 22.3244 12.384 21.1884 12.384C19.1404 12.384 17.0444 13.408 17.0444 15.712C17.0444 17.824 18.5324 18.496 19.9084 18.928C21.3324 19.376 22.5164 19.712 22.5164 20.896C22.5164 22.112 21.4124 22.576 20.4684 22.576C19.5724 22.576 18.5484 22.096 17.9884 21.328L16.5484 22.672C17.4444 23.728 18.9644 24.288 20.4364 24.288C22.6604 24.288 24.5644 23.104 24.5644 20.672C24.5644 18.448 22.7084 17.808 21.2524 17.36C19.9724 16.96 19.0924 16.656 19.0924 15.616C19.0924 14.512 20.1644 14.064 21.0924 14.064C21.8924 14.064 22.7404 14.48 23.1724 15.04L24.4844 13.6ZM26.5199 24H28.4399V16.32H26.5199V24ZM26.2479 13.712C26.2479 14.32 26.7599 14.864 27.4639 14.864C28.1679 14.864 28.7119 14.368 28.7119 13.712C28.7119 13.056 28.1679 12.56 27.4639 12.56C26.7599 12.56 26.2479 13.104 26.2479 13.712ZM36.7532 16.32V17.472H36.7212C36.1612 16.544 35.1532 16.096 34.0812 16.096C31.7612 16.096 30.3212 17.904 30.3212 20.128C30.3212 22.304 31.8092 24.128 34.1132 24.128C35.1692 24.128 36.0652 23.728 36.6252 22.976H36.6572V23.536C36.6572 25.056 36.0812 26.176 34.2252 26.176C33.2652 26.176 32.2732 25.792 31.5372 25.088L30.4332 26.576C31.4252 27.392 32.9932 27.84 34.2412 27.84C37.2332 27.84 38.5772 26.08 38.5772 23.312V16.32H36.7532ZM34.4812 17.664C35.8732 17.664 36.7532 18.784 36.7532 20.112C36.7532 21.392 35.8892 22.544 34.4652 22.544C33.0892 22.544 32.2732 21.328 32.2732 20.112C32.2732 18.752 33.0892 17.664 34.4812 17.664ZM40.8786 24H42.7986V19.776C42.7986 18.752 43.3746 17.696 44.5906 17.696C45.8226 17.696 46.0306 18.832 46.0306 19.744V24H47.9506V19.2C47.9506 17.632 47.1186 16.096 45.1186 16.096C43.9826 16.096 43.0706 16.784 42.7346 17.552H42.7026V16.32H40.8786V24ZM54.2231 24H56.1431V16.32H54.2231V24ZM53.9511 13.712C53.9511 14.32 54.4631 14.864 55.1671 14.864C55.8711 14.864 56.4151 14.368 56.4151 13.712C56.4151 13.056 55.8711 12.56 55.1671 12.56C54.4631 12.56 53.9511 13.104 53.9511 13.712ZM58.4723 24H60.3923V19.776C60.3923 18.752 60.9683 17.696 62.1843 17.696C63.4163 17.696 63.6243 18.832 63.6243 19.744V24H65.5443V19.2C65.5443 17.632 64.7123 16.096 62.7123 16.096C61.5763 16.096 60.6643 16.784 60.3283 17.552H60.2963V16.32H58.4723V24ZM73.3688 24H75.3208L77.0488 18.624H77.0808L78.8248 24H80.7768L83.4328 16.32H81.4328L79.8008 21.824H79.7688L78.1048 16.32H76.0568L74.4088 21.824H74.3768L72.7768 16.32H70.6968L73.3688 24ZM84.6762 24H86.5962V16.32H84.6762V24ZM84.4042 13.712C84.4042 14.32 84.9162 14.864 85.6202 14.864C86.3242 14.864 86.8682 14.368 86.8682 13.712C86.8682 13.056 86.3242 12.56 85.6202 12.56C84.9162 12.56 84.4042 13.104 84.4042 13.712ZM89.1654 17.856V21.44C89.1654 22.912 89.6294 24.16 91.6614 24.16C92.0934 24.16 92.6054 24.08 92.9414 23.952L92.8774 22.448C92.6534 22.56 92.3174 22.608 92.0614 22.608C91.2134 22.608 91.0534 22.112 91.0534 21.424V17.856H92.9734V16.32H91.0534V14.096H89.1654V16.32H87.8214V17.856H89.1654ZM98.6349 16.096C97.4989 16.096 96.6509 16.752 96.3469 17.392H96.3149V11.904H94.3949V24H96.3149V19.808C96.3149 18.784 96.9069 17.744 98.1229 17.744C99.3549 17.744 99.5469 18.864 99.5469 19.776V24H101.467V19.2C101.467 17.632 100.635 16.096 98.6349 16.096ZM107.803 24H109.819V12.672H107.803V24ZM112.222 24H114.142V19.776C114.142 18.752 114.718 17.696 115.934 17.696C117.166 17.696 117.374 18.832 117.374 19.744V24H119.294V19.2C119.294 17.632 118.462 16.096 116.462 16.096C115.326 16.096 114.414 16.784 114.078 17.552H114.046V16.32H112.222V24ZM121.775 17.856V21.44C121.775 22.912 122.239 24.16 124.271 24.16C124.703 24.16 125.215 24.08 125.551 23.952L125.487 22.448C125.263 22.56 124.927 22.608 124.671 22.608C123.823 22.608 123.663 22.112 123.663 21.424V17.856H125.583V16.32H123.663V14.096H121.775V16.32H120.431V17.856H121.775ZM133.98 16.32H132.06V20.544C132.06 21.568 131.484 22.624 130.268 22.624C129.036 22.624 128.828 21.488 128.828 20.576V16.32H126.908V21.12C126.908 22.688 127.74 24.224 129.74 24.224C130.876 24.224 131.788 23.536 132.124 22.768H132.156V24H133.98V16.32ZM136.317 24H138.237V16.32H136.317V24ZM136.045 13.712C136.045 14.32 136.557 14.864 137.261 14.864C137.965 14.864 138.509 14.368 138.509 13.712C138.509 13.056 137.965 12.56 137.261 12.56C136.557 12.56 136.045 13.104 136.045 13.712ZM140.806 17.856V21.44C140.806 22.912 141.27 24.16 143.302 24.16C143.734 24.16 144.246 24.08 144.582 23.952L144.518 22.448C144.294 22.56 143.958 22.608 143.702 22.608C142.854 22.608 142.694 22.112 142.694 21.424V17.856H144.614V16.32H142.694V14.096H140.806V16.32H139.462V17.856H140.806Z" fill="white" />
    </svg>
  ),
};
export const zohoLogo: Icon = {
  label: "zoho",
  icon: (
    <svg xmlns="http://www.w3.org/2000/svg" className="logo-color" viewBox="0 0 1024 1024"><path fill="currentColor" d="M729.54 1024H30c-16.57 0-30-13.43-30-30V739.84c0-55.52 35.28-104.93 87.8-122.96l775.28-266.09C923.44 330.07 964 273.26 964 209.44 964 127.04 896.96 60 814.56 60H60v494.96c0 16.57-13.43 30-30 30s-30-13.43-30-30V30C0 13.43 13.43 0 30 0h784.56C930.05 0 1024 93.95 1024 209.44c0 89.45-56.84 169.06-141.45 198.1L107.28 673.63C79 683.33 60 709.94 60 739.84V964h669.54c62.63 0 121.5-24.39 165.79-68.67C939.61 851.04 964 792.17 964 729.54c0-44.33-12.49-87.56-36.11-125.02-23.39-37.1-56.55-66.79-95.89-85.88-14.91-7.23-21.13-25.18-13.89-40.09 7.23-14.91 25.18-21.13 40.09-13.89 49.42 23.98 91.07 61.28 120.45 107.86 29.68 47.06 45.36 101.36 45.36 157.03 0 78.65-30.63 152.6-86.25 208.22-55.62 55.6-129.57 86.23-208.22 86.23z" opacity=".9" /><path fill="currentColor" d="M337.52 419.82c-66.17 0-120-53.83-120-120s53.83-120 120-120 120 53.83 120 120-53.83 120-120 120zm0-180c-33.08 0-60 26.92-60 60s26.92 60 60 60 60-26.92 60-60-26.92-60-60-60zM638.34 843.53c-66.17 0-120-53.83-120-120s53.83-120 120-120 120 53.83 120 120-53.83 120-120 120zm0-180c-33.08 0-60 26.92-60 60s26.92 60 60 60 60-26.92 60-60-26.92-60-60-60z" opacity=".9" /></svg>
  ),
};

export const cloud: Icon = {
  label: "cloud",
  icon: (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.26906 10.0098C5.73906 9.73976 5.14906 9.59976 4.54906 9.59976C-0.130938 9.92976 -0.130938 16.7398 4.54906 17.0698H15.6391C16.9891 17.0798 18.2891 16.5798 19.2791 15.6698C22.5691 12.7998 20.8091 7.02976 16.4791 6.47976C14.9191 -2.89024 1.38906 0.669757 4.59906 9.59976"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.8496 6.91977C15.3696 6.65977 15.9396 6.51977 16.5196 6.50977"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const danger: Icon = {
  label: "danger",
  icon: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 8V13"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.9994 20.4103H4.93944C1.46944 20.4103 0.0194446 17.9303 1.69944 14.9003L4.81944 9.28027L7.75944 4.00027C9.53944 0.790273 12.4594 0.790273 14.2394 4.00027L17.1794 9.29027L20.2994 14.9103C21.9794 17.9403 20.5194 20.4203 17.0594 20.4203H10.9994V20.4103Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.9941 16H11.0031"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const date: Icon = {
  label: "cloud",
  icon: (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 1V4"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 1V4"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 7.5V16C19 19 17.5 21 14 21H6C2.5 21 1 19 1 16V7.5C1 4.5 2.5 2.5 6 2.5H14C17.5 2.5 19 4.5 19 7.5Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 10H14"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 15H10"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const right: Icon = {
  label: "right",
  icon: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 21C16.5 21 21 16.5 21 11C21 5.5 16.5 1 11 1C5.5 1 1 5.5 1 11C1 16.5 5.5 21 11 21Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.75 11L9.58 13.83L15.25 8.17001"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

// Other icons out from library
export const longBoldArrowRight: Icon = {
  label: "longBoldArrowRight",
  icon: (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 7L16.7071 6.29289L17.4142 7L16.7071 7.70711L16 7ZM1 8C0.447715 8 0 7.55228 0 7C0 6.44772 0.447715 6 1 6V8ZM10.7071 0.292893L16.7071 6.29289L15.2929 7.70711L9.29289 1.70711L10.7071 0.292893ZM16.7071 7.70711L10.7071 13.7071L9.29289 12.2929L15.2929 6.29289L16.7071 7.70711ZM16 8H1V6H16V8Z"
        fill="currentColor"
      />
    </svg>
  ),
};

export const folderCloud: Icon = {
  label: "folderCloud",
  icon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 22H7C3 22 2 21 2 17V7C2 3 3 2 7 2H8.5C10 2 10.33 2.44001 10.9 3.20001L12.4 5.20001C12.78 5.70001 13 6 14 6H17C21 6 22 7 22 11V13" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /><path d="M13.7605 18.3199C11.4105 18.4899 11.4105 21.8899 13.7605 22.0599H19.3205C19.9905 22.0599 20.6506 21.8099 21.1406 21.3599C22.7906 19.9199 21.9105 17.0399 19.7405 16.7699C18.9605 12.0799 12.1806 13.8599 13.7806 18.3299" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /></svg>
  ),
};

export const file: Icon = {
  label: "file",
  icon: (
    <svg
      width="22"
      height="28"
      viewBox="0 0 22 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {" "}
      <path
        d="M12.4286 6.71429V1H5C3.11438 1 2.17157 1 1.58579 1.58579C1 2.17157 1 3.11438 1 5V22.7143C1 24.5999 1 25.5427 1.58579 26.1285C2.17157 26.7143 3.11438 26.7143 5 26.7143H17C18.8856 26.7143 19.8284 26.7143 20.4142 26.1285C21 25.5427 21 24.5999 21 22.7143V9.57143H15.2857C13.9388 9.57143 13.2654 9.57143 12.847 9.15301C12.4286 8.73459 12.4286 8.06116 12.4286 6.71429Z"
        fill="currentColor"
        fill-opacity="0.25"
      />{" "}
      <path
        d="M12.6737 1H6.71429C4.02055 1 2.67368 1 1.83684 1.83684C1 2.67368 1 4.02055 1 6.71429V21C1 23.6937 1 25.0406 1.83684 25.8774C2.67368 26.7143 4.02055 26.7143 6.71429 26.7143H15.2857C17.9795 26.7143 19.3263 26.7143 20.1632 25.8774C21 25.0406 21 23.6937 21 21V9.32632C21 8.74239 21 8.45043 20.8913 8.1879C20.7825 7.92537 20.5761 7.71892 20.1632 7.30602L14.694 1.83684C14.2811 1.42394 14.0746 1.21749 13.8121 1.10874C13.5496 1 13.2576 1 12.6737 1Z"
        stroke="currentColor"
        stroke-width="1.2"
      />{" "}
      <path
        d="M6.71429 15.2858L15.2857 15.2858"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
      />{" "}
      <path
        d="M6.71429 21L12.4286 21"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
      />{" "}
      <path
        d="M12.4286 1V6.71429C12.4286 8.06116 12.4286 8.73459 12.847 9.15301C13.2654 9.57143 13.9388 9.57143 15.2857 9.57143H21"
        stroke="currentColor"
        stroke-width="1.2"
      />{" "}
    </svg>
  ),
};

export const fileupload: Icon = {
  label: "fileupload",
  icon: (
    <svg
      width="22"
      height="25"
      viewBox="0 0 22 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {" "}
      <rect
        x="1"
        y="1"
        width="17.5"
        height="22.5"
        rx="2"
        fill="currentColor"
        fill-opacity="0.25"
      />{" "}
      <path
        d="M4.75 14.75L12.25 14.75"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
      />{" "}
      <path
        d="M4.75 11L9.75 11"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
      />{" "}
      <path
        d="M4.75 18.5L9.75 18.5"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
      />{" "}
      <path
        d="M18.5 13.5V17.5C18.5 20.3284 18.5 21.7426 17.6213 22.6213C16.7426 23.5 15.3284 23.5 12.5 23.5H7C4.17157 23.5 2.75736 23.5 1.87868 22.6213C1 21.7426 1 20.3284 1 17.5V7C1 4.17157 1 2.75736 1.87868 1.87868C2.75736 1 4.17157 1 7 1H9.75"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
      />{" "}
      <path
        d="M17.25 1L17.25 8.5"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
      />{" "}
      <path
        d="M21 4.75L13.5 4.75"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
      />{" "}
    </svg>
  ),
};

export const equalicon: Icon = {
  label: "equal",
  icon: (
    <svg
      width="15"
      height="8"
      viewBox="0 0 15 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {" "}
      <path
        d="M0.169127 1.5999C0.169127 1.29284 0.291105 0.998361 0.508227 0.781239C0.725349 0.564117 1.01983 0.442139 1.32689 0.442139H12.9753C13.276 0.45151 13.5612 0.577536 13.7705 0.79353C13.9799 1.00952 14.097 1.29853 14.097 1.59934C14.097 1.90015 13.9799 2.18915 13.7705 2.40514C13.5612 2.62114 13.276 2.74716 12.9753 2.75653H1.32576C1.01909 2.75594 0.725192 2.6337 0.508555 2.41664C0.291919 2.19958 0.17025 1.90544 0.170251 1.59877L0.169127 1.5999ZM14.1319 6.77497C14.1319 7.08203 14.01 7.37651 13.7928 7.59363C13.5757 7.81075 13.2812 7.93273 12.9742 7.93273H1.32689C1.17189 7.93756 1.0175 7.91121 0.872877 7.85522C0.728258 7.79924 0.59636 7.71478 0.48501 7.60685C0.37366 7.49891 0.285129 7.36971 0.22467 7.22691C0.164211 7.0841 0.133057 6.93061 0.133057 6.77553C0.133057 6.62046 0.164211 6.46696 0.22467 6.32416C0.285129 6.18136 0.37366 6.05215 0.48501 5.94422C0.59636 5.83629 0.728258 5.75182 0.872877 5.69584C1.0175 5.63986 1.17189 5.6135 1.32689 5.61834H12.9764C13.2833 5.61863 13.5775 5.74074 13.7944 5.95783C14.0112 6.17492 14.1331 6.46923 14.1331 6.7761L14.1319 6.77497Z"
        fill="currentColor"
      />{" "}
    </svg>
  ),
};

export const reset: Icon = {
  label: "reset",
  icon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {" "}
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 0V2.22222C14.2878 2.22222 17.7778 5.71111 17.7778 10C17.7778 14.2889 14.2878 17.7778 10 17.7778C5.71222 17.7778 2.22222 14.2889 2.22222 10C2.22222 7.94778 3.03889 6.01555 4.44445 4.57555V7.22222H6.66667V1.11111H0.555552V3.33333H2.54555C0.923333 5.14667 0 7.51 0 10C0 15.5133 4.48555 20 10 20C15.5144 20 20 15.5133 20 10C20 4.48667 15.5144 0 10 0Z"
        fill="currentColor"
      />{" "}
    </svg>
  ),
};

export const saveMapping: Icon = {
  label: "savemaping",
  icon: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {" "}
      <path
        d="M15 7.98999V19.35C15 20.8 13.96 21.41 12.69 20.71L8.76001 18.52C8.34001 18.29 7.65999 18.29 7.23999 18.52L3.31 20.71C2.04 21.41 1 20.8 1 19.35V7.98999C1 6.27999 2.39999 4.88 4.10999 4.88H11.89C13.6 4.88 15 6.27999 15 7.98999Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />{" "}
      <path
        d="M21 4.10999V15.47C21 16.92 19.96 17.53 18.69 16.83L15 14.77V7.98999C15 6.27999 13.6 4.88 11.89 4.88H7V4.10999C7 2.39999 8.39999 1 10.11 1H17.89C19.6 1 21 2.39999 21 4.10999Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />{" "}
      <path
        d="M6 11H10"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />{" "}
      <path
        d="M8 13V9"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />{" "}
    </svg>
  ),
};

export const copyToClipboard: Icon = {
  label: "copyToClipboard",
  icon: (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4V1C4 0.734784 4.10536 0.48043 4.29289 0.292893C4.48043 0.105357 4.73478 0 5 0H17C17.2652 0 17.5196 0.105357 17.7071 0.292893C17.8946 0.48043 18 0.734784 18 1V15C18 15.2652 17.8946 15.5196 17.7071 15.7071C17.5196 15.8946 17.2652 16 17 16H14V19C14 19.552 13.55 20 12.993 20H1.007C0.875127 20.0008 0.744397 19.9755 0.622322 19.9256C0.500247 19.8757 0.389233 19.8022 0.295659 19.7093C0.202084 19.6164 0.127793 19.5059 0.0770543 19.3841C0.0263156 19.2624 0.000129374 19.1319 0 19L0.00300002 5C0.00300002 4.448 0.453 4 1.009 4H4ZM2.002 6L2 18H12V6H2.002ZM6 4H14V14H16V2H6V4Z"
        fill="currentColor"
      />
    </svg>
  ),
};


export const errorIcon: Icon = {
  label: 'erroricon',
  icon: <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11 8V13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M10.9994 20.4103H4.93944C1.46944 20.4103 0.0194446 17.9303 1.69944 14.9003L4.81944 9.28027L7.75944 4.00027C9.53944 0.790273 12.4594 0.790273 14.2394 4.00027L17.1794 9.29027L20.2994 14.9103C21.9794 17.9403 20.5194 20.4203 17.0594 20.4203H10.9994V20.4103Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M10.9941 16H11.0031" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /> </svg>
}

export const successIcon: Icon = {
  label: 'successicon',
  icon: <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.375 10.9925L9.785 13.4125L14.615 8.57251" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M9.745 1.4425C10.435 0.8525 11.565 0.8525 12.265 1.4425L13.845 2.8025C14.145 3.0625 14.705 3.2725 15.105 3.2725H16.805C17.865 3.2725 18.735 4.1425 18.735 5.2025V6.9025C18.735 7.2925 18.945 7.8625 19.205 8.1625L20.565 9.7425C21.155 10.4325 21.155 11.5625 20.565 12.2625L19.205 13.8425C18.945 14.1425 18.735 14.7025 18.735 15.1025V16.8025C18.735 17.8625 17.865 18.7325 16.805 18.7325H15.105C14.715 18.7325 14.145 18.9425 13.845 19.2025L12.265 20.5625C11.575 21.1525 10.445 21.1525 9.745 20.5625L8.165 19.2025C7.865 18.9425 7.305 18.7325 6.905 18.7325H5.175C4.115 18.7325 3.245 17.8625 3.245 16.8025V15.0925C3.245 14.7025 3.035 14.1425 2.785 13.8425L1.435 12.2525C0.855 11.5625 0.855 10.4425 1.435 9.7525L2.785 8.1625C3.035 7.8625 3.245 7.3025 3.245 6.9125V5.1925C3.245 4.1325 4.115 3.2625 5.175 3.2625H6.905C7.295 3.2625 7.865 3.0525 8.165 2.7925L9.745 1.4425Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> </svg>
}

export const documentIcon: Icon = {
  label: 'documenticon',
  icon: <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M21 9V14C21 19 19 21 14 21H8C3 21 1 19 1 14V8C1 3 3 1 8 1H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M21 9H17C14 9 13 8 13 5V1L21 9Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M6 12H12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M6 16H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> </svg>
}

export const sheetIcon: Icon = {
  label: 'sheeticon',
  icon: <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.3701 7.88H16.6201" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M5.37988 7.88L6.12988 8.63L8.37988 6.38" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M11.3701 14.88H16.6201" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M5.37988 14.88L6.12988 15.63L8.37988 13.38" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M8 21H14C19 21 21 19 21 14V8C21 3 19 1 14 1H8C3 1 1 3 1 8V14C1 19 3 21 8 21Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> </svg>
}

export const downloadIcon: Icon = {
  label: 'downloadicon',
  icon: <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6.32007 8.68005L8.88007 11.2401L11.4401 8.68005" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /> <path d="M8.87988 1V11.17" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /> <path d="M17 9.18005C17 13.6001 14 17.1801 9 17.1801C4 17.1801 1 13.6001 1 9.18005" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" /> </svg>
}

export const detailInfo: Icon = {
  label: 'detailinfo',
  icon: <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
    <path d="M9.5 7.91667C9.70996 7.91667 9.91133 8.00007 10.0598 8.14854C10.2083 8.29701 10.2917 8.49837 10.2917 8.70833V13.4583C10.2917 13.6683 10.2083 13.8697 10.0598 14.0181C9.91133 14.1666 9.70996 14.25 9.5 14.25C9.29004 14.25 9.08867 14.1666 8.94021 14.0181C8.79174 13.8697 8.70833 13.6683 8.70833 13.4583V8.70833C8.70833 8.49837 8.79174 8.29701 8.94021 8.14854C9.08867 8.00007 9.29004 7.91667 9.5 7.91667ZM9.5 6.72917C9.65594 6.72917 9.81036 6.69845 9.95444 6.63877C10.0985 6.5791 10.2294 6.49163 10.3397 6.38136C10.45 6.27109 10.5374 6.14018 10.5971 5.9961C10.6568 5.85203 10.6875 5.69761 10.6875 5.54167C10.6875 5.38572 10.6568 5.2313 10.5971 5.08723C10.5374 4.94316 10.45 4.81225 10.3397 4.70198C10.2294 4.59171 10.0985 4.50424 9.95444 4.44456C9.81036 4.38488 9.65594 4.35417 9.5 4.35417C9.18548 4.35417 8.88383 4.47911 8.66143 4.70151C8.43903 4.92392 8.31408 5.22556 8.31408 5.54008C8.31408 5.85461 8.43903 6.15625 8.66143 6.37865C8.88383 6.60106 9.18548 6.726 9.5 6.726V6.72917ZM0 9.5C-1.85901e-08 8.25244 0.245725 7.0171 0.723144 5.86451C1.20056 4.71191 1.90033 3.66464 2.78249 2.78249C3.66464 1.90033 4.71191 1.20056 5.86451 0.723145C7.0171 0.245725 8.25244 0 9.5 0C10.7476 0 11.9829 0.245725 13.1355 0.723145C14.2881 1.20056 15.3354 1.90033 16.2175 2.78249C17.0997 3.66464 17.7994 4.71191 18.2769 5.86451C18.7543 7.0171 19 8.25244 19 9.5C19 12.0196 17.9991 14.4359 16.2175 16.2175C14.4359 17.9991 12.0196 19 9.5 19C6.98044 19 4.56408 17.9991 2.78249 16.2175C1.00089 14.4359 3.75443e-08 12.0196 0 9.5ZM9.5 1.58333C7.40037 1.58333 5.38673 2.41741 3.90207 3.90207C2.41741 5.38673 1.58333 7.40037 1.58333 9.5C1.58333 11.5996 2.41741 13.6133 3.90207 15.0979C5.38673 16.5826 7.40037 17.4167 9.5 17.4167C11.5996 17.4167 13.6133 16.5826 15.0979 15.0979C16.5826 13.6133 17.4167 11.5996 17.4167 9.5C17.4167 7.40037 16.5826 5.38673 15.0979 3.90207C13.6133 2.41741 11.5996 1.58333 9.5 1.58333Z" fill="currentColor" />
  </svg>
}

export const connectIcon: Icon = {
  label: 'connecticon',
  icon: <svg fill="currentColor" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 511.997 511.997">
    <path d="M212.26,390.24l-60.331,60.331c-25.012,25.012-65.517,25.012-90.508,0.005c-24.996-24.996-24.996-65.505-0.005-90.496
          l120.683-120.683c24.991-24.992,65.5-24.992,90.491,0c8.331,8.331,21.839,8.331,30.17,0c8.331-8.331,8.331-21.839,0-30.17
          c-41.654-41.654-109.177-41.654-150.831,0L31.247,329.909c-41.654,41.654-41.654,109.177,0,150.831
          c41.649,41.676,109.177,41.676,150.853,0l60.331-60.331c8.331-8.331,8.331-21.839,0-30.17S220.591,381.909,212.26,390.24z"/>
    <path d="M480.751,31.24c-41.654-41.654-109.199-41.654-150.853,0l-72.384,72.384c-8.331,8.331-8.331,21.839,0,30.17
          c8.331,8.331,21.839,8.331,30.17,0l72.384-72.384c24.991-24.992,65.521-24.992,90.513,0c24.991,24.991,24.991,65.5,0,90.491
          L317.845,284.638c-24.992,24.992-65.5,24.992-90.491,0c-8.331-8.331-21.839-8.331-30.17,0s-8.331,21.839,0,30.17
          c41.654,41.654,109.177,41.654,150.831,0l132.736-132.736C522.405,140.418,522.405,72.894,480.751,31.24z"/>
  </svg>
}

export const viewIcon: Icon = {
  label: 'viewIcon',
  icon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" fill="none">
    <circle cx="10" cy="7" r="3.5" stroke="currentColor" />
    <path d="M18.188 5.93429C18.5762 6.40556 18.7703 6.64119 18.7703 7C18.7703 7.35881 18.5762 7.59444 18.188 8.06571C16.7679 9.78986 13.6357 13 10 13C6.36427 13 3.23206 9.78986 1.81197 8.06571C1.42381 7.59444 1.22973 7.35881 1.22973 7C1.22973 6.64119 1.42381 6.40556 1.81197 5.93429C3.23206 4.21014 6.36427 1 10 1C13.6357 1 16.7679 4.21014 18.188 5.93429Z" stroke="currentColor" />
  </svg>
}
export const hideIcon: Icon = {
  label: 'hideIcon',
  icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9202 12.7988C15.9725 12.5407 16 12.2736 16 12C16 9.79086 14.2091 8 12 8C11.7264 8 11.4593 8.02746 11.2012 8.07977L12.1239 9.00251C13.6822 9.06583 14.9342 10.3178 14.9975 11.8761L15.9202 12.7988ZM9.39311 10.5143C9.14295 10.9523 9 11.4595 9 12C9 13.6569 10.3431 15 12 15C12.5405 15 13.0477 14.857 13.4857 14.6069L14.212 15.3332C13.5784 15.7545 12.8179 16 12 16C9.79086 16 8 14.2091 8 12C8 11.1821 8.24547 10.4216 8.66676 9.78799L9.39311 10.5143Z" fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1537 17.2751L15.4193 16.5406C14.3553 17.1196 13.1987 17.5 12 17.5C10.3282 17.5 8.73816 16.7599 7.36714 15.7735C6.00006 14.79 4.89306 13.5918 4.19792 12.7478C3.77356 12.2326 3.72974 12.1435 3.72974 12C3.72974 11.8565 3.77356 11.7674 4.19792 11.2522C4.86721 10.4396 5.9183 9.29863 7.21572 8.33704L6.50139 7.62271C5.16991 8.63072 4.10383 9.79349 3.42604 10.6164L3.36723 10.6876C3.03671 11.087 2.72974 11.4579 2.72974 12C2.72974 12.5421 3.0367 12.913 3.36723 13.3124L3.42604 13.3836C4.15099 14.2638 5.32014 15.5327 6.78312 16.5853C8.24216 17.635 10.0361 18.5 12 18.5C13.5101 18.5 14.9196 17.9886 16.1537 17.2751ZM9.18993 6.06861C10.0698 5.71828 11.0135 5.5 12 5.5C13.9639 5.5 15.7579 6.365 17.2169 7.41472C18.6799 8.46727 19.849 9.73623 20.574 10.6164L20.6328 10.6876C20.9633 11.087 21.2703 11.4579 21.2703 12C21.2703 12.5421 20.9633 12.913 20.6328 13.3124L20.574 13.3836C20.0935 13.9669 19.418 14.721 18.5911 15.4697L17.883 14.7617C18.6787 14.0456 19.3338 13.3164 19.8021 12.7478C20.2265 12.2326 20.2703 12.1435 20.2703 12C20.2703 11.8565 20.2265 11.7674 19.8021 11.2522C19.107 10.4082 18 9.21001 16.6329 8.22646C15.2619 7.24007 13.6718 6.5 12 6.5C11.3056 6.5 10.6253 6.62768 9.96897 6.84765L9.18993 6.06861Z" fill="currentColor" />
    <path d="M5 2L21 18" stroke="currentColor" />
  </svg>
}


export const saveIcon: Icon = {
  label: 'saveIcon',
  icon: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" viewBox="0 0 16 21" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 3C0 2.20435 0.316071 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0H13C13.7956 0 14.5587 0.316071 15.1213 0.87868C15.6839 1.44129 16 2.20435 16 3V19.028C16 20.248 14.62 20.958 13.628 20.249L8 16.229L2.372 20.249C1.379 20.959 0 20.249 0 19.029V3ZM3 2C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V18.057L7.128 14.394C7.38243 14.2122 7.68731 14.1145 8 14.1145C8.31269 14.1145 8.61757 14.2122 8.872 14.394L14 18.057V3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2H3Z" fill="currentColor" />
  </svg>
}

export const rightIcon: Icon = {
  label: 'rightIcon',
  icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="17" viewBox="0 0 24 17" fill="none">
    <path d="M1.71754 9.61518L7.29725 14.8978C7.68723 15.267 8.29921 15.2622 8.68343 14.887L22.0168 1.86639" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
  </svg>
}

export const clickIcon: Icon = {
  label: 'clickIcon',
  icon: <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <path d="M9.71 15.99C8.17063 15.9172 6.71846 15.2542 5.65514 14.1388C4.59181 13.0233 3.99905 11.5411 4 10C4 6.69 6.69 4 10 4C13.22 4 15.84 6.53 15.99 9.71L13.89 9.08C13.7266 8.38678 13.3809 7.74979 12.8889 7.23488C12.3968 6.71996 11.7761 6.34581 11.091 6.15108C10.4059 5.95636 9.68128 5.94814 8.99195 6.12728C8.30262 6.30641 7.67363 6.66639 7.17001 7.17001C6.66639 7.67363 6.30641 8.30262 6.12728 8.99195C5.94814 9.68128 5.95636 10.4059 6.15108 11.091C6.34581 11.7761 6.71996 12.3968 7.23488 12.8889C7.74979 13.3809 8.38678 13.7266 9.08 13.89L9.71 15.99ZM20 10C20 10.3 19.99 10.6 19.96 10.9L17.99 10.31C18 10.21 18 10.1 18 10C18 5.58 14.42 2 10 2C5.58 2 2 5.58 2 10C2 14.42 5.58 18 10 18C10.1 18 10.21 18 10.31 17.99L10.9 19.96C10.6 19.99 10.3 20 10 20C4.48 20 0 15.52 0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10ZM16.23 14.26L18.5 13.5C18.96 13.35 18.95 12.69 18.49 12.55L10.89 10.27C10.51 10.16 10.15 10.51 10.27 10.89L12.55 18.49C12.69 18.96 13.35 18.97 13.5 18.5L14.26 16.23L18.17 20.14C18.37 20.34 18.68 20.34 18.88 20.14L20.15 18.87C20.35 18.67 20.35 18.36 20.15 18.16L16.23 14.26Z" fill="currentColor" />
  </svg>
}
export const copyIcon: Icon = {
  label: 'copyIcon',
  icon: <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
    <path d="M4 0C3.46957 0 2.96086 0.210714 2.58579 0.585786C2.21071 0.960859 2 1.46957 2 2V12C2 12.5304 2.21071 13.0391 2.58579 13.4142C2.96086 13.7893 3.46957 14 4 14H10C10.5304 14 11.0391 13.7893 11.4142 13.4142C11.7893 13.0391 12 12.5304 12 12V2C12 1.46957 11.7893 0.960859 11.4142 0.585786C11.0391 0.210714 10.5304 0 10 0H4ZM3 2C3 1.73478 3.10536 1.48043 3.29289 1.29289C3.48043 1.10536 3.73478 1 4 1H10C10.2652 1 10.5196 1.10536 10.7071 1.29289C10.8946 1.48043 11 1.73478 11 2V12C11 12.2652 10.8946 12.5196 10.7071 12.7071C10.5196 12.8946 10.2652 13 10 13H4C3.73478 13 3.48043 12.8946 3.29289 12.7071C3.10536 12.5196 3 12.2652 3 12V2ZM0 4C8.91844e-06 3.64894 0.0924258 3.30406 0.267962 3.00003C0.443498 2.696 0.695969 2.44353 1 2.268V12.5C1 13.163 1.26339 13.7989 1.73223 14.2678C2.20107 14.7366 2.83696 15 3.5 15H9.732C9.55647 15.304 9.304 15.5565 8.99997 15.732C8.69594 15.9076 8.35106 16 8 16H3.5C2.57174 16 1.6815 15.6313 1.02513 14.9749C0.368749 14.3185 0 13.4283 0 12.5V4Z" fill="currentColor" />
  </svg>
}
export const errorlogIcon: Icon = {
  label: 'errorlogIcon',
  icon: <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 21 23" fill="none">
    <path d="M5 5L9 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    <path d="M5 13L8 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    <path d="M5 9L11 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    <path d="M15 9V7C15 4.17157 15 2.75736 14.1213 1.87868C13.2426 1 11.8284 1 9 1H7C4.17157 1 2.75736 1 1.87868 1.87868C1 2.75736 1 4.17157 1 7V13C1 15.8284 1 17.2426 1.87868 18.1213C2.75736 19 4.17157 19 7 19H8" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" />
    <path d="M14.5167 16.8667C14.4018 16.8667 14.2916 16.821 14.2103 16.7397C14.129 16.6585 14.0834 16.5483 14.0834 16.4333V14.4333C14.0834 14.3184 14.129 14.2082 14.2103 14.1269C14.2916 14.0457 14.4018 14 14.5167 14C14.6316 14 14.7419 14.0457 14.8231 14.1269C14.9044 14.2082 14.95 14.3184 14.95 14.4333V16.4333C14.95 16.5483 14.9044 16.6585 14.8231 16.7397C14.7419 16.821 14.6316 16.8667 14.5167 16.8667Z" fill="currentColor" />
    <path d="M14.5 18.35C14.7761 18.35 15 18.1262 15 17.85C15 17.5739 14.7761 17.35 14.5 17.35C14.2239 17.35 14 17.5739 14 17.85C14 18.1262 14.2239 18.35 14.5 18.35Z" fill="currentColor" />
    <path d="M14.933 11.75L18.8301 18.5C19.0226 18.8333 18.782 19.25 18.3971 19.25H10.6029C10.218 19.25 9.97742 18.8333 10.1699 18.5L14.067 11.75C14.2594 11.4167 14.7406 11.4167 14.933 11.75Z" stroke="currentColor" />
  </svg>
}
export const progressIcon: Icon = {
  label: 'progressIcon',
  icon: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
    <path d="M17.5812 22H0V20.1667H1.91795C0.639316 15.5833 3.19658 13.75 4.87479 12.4667C5.59402 11.9167 6.31325 11.4583 6.31325 11C6.31325 10.5417 5.59402 9.99167 4.87479 9.53333C3.19658 8.25 0.639316 6.50833 1.91795 1.83333H0V0H17.5812V1.83333H15.6632C16.9419 6.41667 14.3846 8.25 12.7064 9.53333C11.9073 9.99167 11.188 10.5417 11.188 11C11.188 11.4583 11.9073 12.0083 12.6265 12.4667C14.3047 13.75 16.862 15.5833 15.5833 20.1667H17.5812V22ZM3.67607 20.1667H13.9051C15.1838 16.5 13.5056 15.3083 11.8274 14.025C10.7085 13.2917 9.58974 12.4667 9.58974 11C9.58974 9.53333 10.7085 8.70833 11.8274 7.975C13.5056 6.69167 15.1838 5.5 13.9051 1.83333H3.67607C2.39744 5.5 4.07564 6.69167 5.75385 7.975C6.87265 8.70833 7.99145 9.53333 7.99145 11C7.99145 12.4667 6.87265 13.2917 5.75385 14.025C4.07564 15.3083 2.39744 16.5 3.67607 20.1667Z" fill="currentColor" />
    <path d="M12.6265 21.0834H4.79492C4.55517 19.7084 4.95475 18.8834 6.63295 17.1417C7.27227 16.5001 8.07141 15.7667 8.79064 14.5751C9.58979 15.6751 10.3889 16.5001 10.9483 17.1417C12.6265 18.9751 13.0261 19.2501 12.6265 21.0834Z" fill="currentColor" />
    <path d="M6.71283 5.5C6.15342 6.69167 6.15343 6.69167 7.43206 7.425C7.83163 7.60833 8.31112 7.88333 8.71069 8.25C9.11026 7.88333 9.66966 7.60833 9.98932 7.425C11.3479 6.69167 11.3479 6.69167 10.7885 5.5" fill="currentColor" />
  </svg>
}

export const cancelledIcon: Icon = {
  label: 'cancelledIcon',
  icon: (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 20.5C16.2467 20.5 20.5 16.2467 20.5 11C20.5 5.75329 16.2467 1.5 11 1.5C5.75329 1.5 1.5 5.75329 1.5 11C1.5 16.2467 5.75329 20.5 11 20.5Z" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8 8L14 14M14 8L8 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
}

export const close: Icon = {
  label: "close",
  icon: (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.8807 4.13589C32.2693 3.73354 32.4843 3.19466 32.4794 2.6353C32.4746 2.07595 32.2502 1.54088 31.8547 1.14535C31.4591 0.74981 30.9241 0.525449 30.3647 0.520588C29.8054 0.515728 29.2665 0.730757 28.8641 1.11936L16.5057 13.4778L4.14734 1.11936C3.74499 0.730757 3.2061 0.515728 2.64675 0.520588C2.08739 0.525449 1.55233 0.74981 1.15679 1.14535C0.761254 1.54088 0.536893 2.07595 0.532032 2.6353C0.527172 3.19466 0.742201 3.73354 1.1308 4.13589L13.4892 16.4943L1.1308 28.8527C0.92705 29.0495 0.764527 29.2849 0.652721 29.5452C0.540915 29.8054 0.482065 30.0854 0.479603 30.3686C0.477142 30.6519 0.531118 30.9328 0.638384 31.195C0.74565 31.4572 0.904057 31.6954 1.10436 31.8957C1.30467 32.096 1.54286 32.2544 1.80504 32.3616C2.06721 32.4689 2.34813 32.5229 2.63139 32.5204C2.91466 32.518 3.19459 32.4591 3.45487 32.3473C3.71514 32.2355 3.95054 32.073 4.14734 31.8692L16.5057 19.5108L28.8641 31.8692C29.2665 32.2578 29.8054 32.4729 30.3647 32.468C30.9241 32.4631 31.4591 32.2388 31.8547 31.8432C32.2502 31.4477 32.4746 30.9126 32.4794 30.3533C32.4843 29.7939 32.2693 29.255 31.8807 28.8527L19.5223 16.4943L31.8807 4.13589Z"
        fill="currentColor"
      />
    </svg>
  ),
};
export const searchIcon: Icon = {
  label: "search",
  icon: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M27.6 25.8L22 20.2C23.3 18.5 24.1 16.4 24.1 14.1C24.1 8.59998 19.6 4.09998 14.1 4.09998C8.6 4.09998 4 8.59998 4 14.1C4 19.6 8.5 24.1 14 24.1C16.3 24.1 18.5 23.3 20.2 21.9L25.8 27.5C26 27.7 26.4 27.9 26.7 27.9C27 27.9 27.3 27.8 27.6 27.5C28.1 27.1 28.1 26.3 27.6 25.8ZM6.5 14.1C6.5 9.99998 9.9 6.59998 14 6.59998C18.1 6.59998 21.5 9.99998 21.5 14.1C21.5 18.2 18.1 21.6 14 21.6C9.9 21.6 6.5 18.3 6.5 14.1Z" />
    </svg>
  ),
};
export const modifyIcon: Icon = {
  label: "modification",
  icon: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Group 10943">
        <path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M18.8969 3.16534C18.992 3.30955 19.0343 3.48212 19.0168 3.65393C18.9993 3.82573 18.9231 3.98624 18.8009 4.10834L9.60794 13.3003C9.5139 13.3943 9.39656 13.4616 9.26794 13.4953L5.43894 14.4953C5.31237 14.5284 5.17937 14.5277 5.05313 14.4934C4.9269 14.4591 4.81183 14.3924 4.71933 14.2999C4.62684 14.2075 4.56015 14.0924 4.52587 13.9661C4.4916 13.8399 4.49093 13.7069 4.52394 13.5803L5.52394 9.75234C5.55313 9.63743 5.6082 9.53071 5.68494 9.44034L14.9119 0.21934C15.0526 0.0788896 15.2432 0 15.4419 0C15.6407 0 15.8313 0.0788896 15.9719 0.21934L18.8009 3.04734C18.8368 3.08335 18.869 3.12288 18.8969 3.16534ZM17.2099 3.57734L15.4419 1.81034L6.92394 10.3283L6.29894 12.7213L8.69194 12.0963L17.2099 3.57734Z" fill="currentColor" />
        <path id="Vector_2" d="M17.083 14.9093C17.3563 12.5733 17.4436 10.2192 17.344 7.86934C17.3418 7.81398 17.3511 7.75876 17.3712 7.70714C17.3913 7.65553 17.4219 7.60861 17.4609 7.56934L18.445 6.58534C18.4718 6.5583 18.506 6.5396 18.5432 6.53148C18.5805 6.52337 18.6193 6.52619 18.655 6.5396C18.6907 6.55301 18.7218 6.57645 18.7445 6.60709C18.7672 6.63773 18.7805 6.67428 18.7829 6.71234C18.9682 9.50357 18.8979 12.3059 18.573 15.0843C18.337 17.1063 16.7129 18.6913 14.6999 18.9163C11.2053 19.3033 7.6786 19.3033 4.18395 18.9163C2.17195 18.6913 0.54695 17.1063 0.31095 15.0843C-0.10365 11.5398 -0.10365 7.95892 0.31095 4.41434C0.54695 2.39234 2.17095 0.807337 4.18395 0.582337C6.83632 0.288219 9.50868 0.21697 12.1729 0.369337C12.2111 0.372075 12.2476 0.385683 12.2783 0.408549C12.3089 0.431415 12.3323 0.462582 12.3458 0.498358C12.3593 0.534134 12.3622 0.57302 12.3543 0.610412C12.3463 0.647804 12.3278 0.682134 12.301 0.709337L11.308 1.70134C11.2691 1.74009 11.2226 1.77046 11.1716 1.79058C11.1205 1.8107 11.0658 1.82015 11.011 1.81834C8.78771 1.74276 6.56191 1.82798 4.35095 2.07334C3.70489 2.14484 3.1018 2.43206 2.6391 2.88859C2.17641 3.34512 1.88112 3.9443 1.80095 4.58934C1.4 8.01765 1.4 11.481 1.80095 14.9093C1.88112 15.5544 2.17641 16.1536 2.6391 16.6101C3.1018 17.0666 3.70489 17.3538 4.35095 17.4253C7.70595 17.8003 11.1779 17.8003 14.5339 17.4253C15.18 17.3538 15.7831 17.0666 16.2458 16.6101C16.7085 16.1536 17.0028 15.5544 17.083 14.9093Z" fill="currentColor" />
      </g>
    </svg>
  ),
};
export const invoiceIcon: Icon = {
  label: "invoice",
  icon: (
    <svg fill="currentColor" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512.002 512.002">
      <g>
        <g>
          <g>
            <path d="M128.257,392.533h-0.085c-4.71,0-8.491,3.823-8.491,8.533s3.866,8.533,8.576,8.533s8.533-3.823,8.533-8.533
    					S132.967,392.533,128.257,392.533z"/>
            <path d="M179.457,392.533h-0.085c-4.71,0-8.491,3.823-8.491,8.533s3.866,8.533,8.576,8.533s8.533-3.823,8.533-8.533
    					S184.167,392.533,179.457,392.533z"/>
            <path d="M247.468,273.067h-68.267c-4.719,0-8.533,3.823-8.533,8.533s3.814,8.533,8.533,8.533h68.267
    					c4.719,0,8.533-3.823,8.533-8.533S252.187,273.067,247.468,273.067z"/>
            <path d="M213.334,324.267h-34.133c-4.719,0-8.533,3.823-8.533,8.533c0,4.71,3.814,8.533,8.533,8.533h34.133
    					c4.719,0,8.533-3.823,8.533-8.533C221.868,328.09,218.053,324.267,213.334,324.267z"/>
            <path d="M358.401,298.667c-9.412,0-17.067-7.654-17.067-17.067c0-4.71-3.814-8.533-8.533-8.533s-8.533,3.823-8.533,8.533
    					c0,15.855,10.914,29.107,25.6,32.922v1.212c0,4.71,3.814,8.533,8.533,8.533c4.719,0,8.533-3.823,8.533-8.533v-1.212
    					c14.686-3.814,25.6-17.067,25.6-32.922c0-18.825-15.309-34.133-34.133-34.133c-9.412,0-17.067-7.654-17.067-17.067
    					c0-9.412,7.654-17.067,17.067-17.067c9.412,0,17.067,7.654,17.067,17.067c0,4.71,3.814,8.533,8.533,8.533
    					s8.533-3.823,8.533-8.533c0-15.855-10.914-29.107-25.6-32.922v-1.212c0-4.71-3.814-8.533-8.533-8.533
    					c-4.719,0-8.533,3.823-8.533,8.533v1.212c-14.686,3.814-25.6,17.067-25.6,32.922c0,18.825,15.309,34.133,34.133,34.133
    					c9.412,0,17.067,7.654,17.067,17.067C375.468,291.012,367.813,298.667,358.401,298.667z"/>
            <path d="M333.057,392.533h-0.085c-4.71,0-8.491,3.823-8.491,8.533s3.866,8.533,8.576,8.533c4.71,0,8.533-3.823,8.533-8.533
    					S337.768,392.533,333.057,392.533z"/>
            <path d="M435.457,409.6c4.71,0,8.533-3.823,8.533-8.533s-3.823-8.533-8.533-8.533h-0.085c-4.71,0-8.491,3.823-8.491,8.533
    					S430.747,409.6,435.457,409.6z"/>
            <path d="M384.257,392.533h-0.085c-4.71,0-8.491,3.823-8.491,8.533s3.866,8.533,8.576,8.533c4.71,0,8.533-3.823,8.533-8.533
    					S388.968,392.533,384.257,392.533z"/>
            <path d="M349.868,102.4h34.133c4.719,0,8.533-3.823,8.533-8.533c0-4.71-3.814-8.533-8.533-8.533h-34.133
    					c-4.719,0-8.533,3.823-8.533,8.533C341.334,98.577,345.149,102.4,349.868,102.4z"/>
            <path d="M230.657,392.533h-0.085c-4.71,0-8.491,3.823-8.491,8.533s3.866,8.533,8.576,8.533s8.533-3.823,8.533-8.533
    					S235.367,392.533,230.657,392.533z"/>
            <path d="M128.001,290.133h17.067c4.719,0,8.533-3.823,8.533-8.533s-3.814-8.533-8.533-8.533h-17.067
    					c-4.719,0-8.533,3.823-8.533,8.533S123.282,290.133,128.001,290.133z"/>
            <path d="M128.001,341.333h17.067c4.719,0,8.533-3.823,8.533-8.533c0-4.71-3.814-8.533-8.533-8.533h-17.067
    					c-4.719,0-8.533,3.823-8.533,8.533C119.468,337.51,123.282,341.333,128.001,341.333z"/>
            <path d="M469.334,0H42.668c-4.719,0-8.533,3.823-8.533,8.533v494.933c0,3.447,2.074,6.562,5.265,7.885
    					c1.058,0.435,2.167,0.648,3.268,0.648c2.219,0,4.403-0.87,6.033-2.5l45.167-45.167l45.167,45.167
    					c3.337,3.337,8.73,3.337,12.066,0l28.1-28.1l28.1,28.1c3.337,3.337,8.73,3.337,12.066,0l28.1-28.1l11.034,11.034
    					c3.337,3.336,8.73,3.336,12.066,0l28.1-28.1l28.1,28.1c3.337,3.336,8.73,3.336,12.066,0l19.567-19.567l19.567,19.567
    					c3.337,3.336,8.73,3.336,12.066,0l45.167-45.167l28.1,28.1c0.171,0.179,0.35,0.341,0.538,0.495c0,0.009,0.008,0.009,0.008,0.009
    					v0.009c1.399,1.169,3.174,1.894,5.112,1.98c0.316,0.009,0.631,0.009,0.964-0.009h0.009c1.724-0.128,3.311-0.751,4.599-1.749
    					c0.461-0.35,0.879-0.751,1.254-1.186c1.289-1.493,2.074-3.43,2.082-5.564v-0.017V8.533C477.868,3.823,474.053,0,469.334,0z
    					 M460.801,448.734l-19.567-19.567c-3.337-3.336-8.73-3.336-12.066,0l-45.167,45.167l-19.567-19.567
    					c-3.336-3.337-8.73-3.337-12.066,0l-19.567,19.567l-28.1-28.1c-3.336-3.337-8.73-3.337-12.066,0l-28.1,28.1L253.501,463.3
    					c-3.337-3.337-8.73-3.337-12.066,0l-28.1,28.1l-28.1-28.1c-1.664-1.664-3.849-2.5-6.033-2.5c-2.185,0-4.369,0.836-6.033,2.5
    					l-28.1,28.1l-45.167-45.167c-3.337-3.337-8.73-3.337-12.066,0l-36.634,36.634V17.067h409.6V448.734z"/>
            <path d="M77.057,409.6c4.71,0,8.533-3.823,8.533-8.533s-3.823-8.533-8.533-8.533h-0.085c-4.71,0-8.491,3.823-8.491,8.533
    					S72.347,409.6,77.057,409.6z"/>
            <path d="M128.001,238.933h17.067c4.719,0,8.533-3.823,8.533-8.533s-3.814-8.533-8.533-8.533h-17.067
    					c-4.719,0-8.533,3.823-8.533,8.533S123.282,238.933,128.001,238.933z"/>
            <path d="M281.857,409.6c4.71,0,8.533-3.823,8.533-8.533s-3.823-8.533-8.533-8.533h-0.085c-4.71,0-8.491,3.823-8.491,8.533
    					S277.147,409.6,281.857,409.6z"/>
            <path d="M179.201,187.733h51.2c4.719,0,8.533-3.823,8.533-8.533s-3.814-8.533-8.533-8.533h-51.2
    					c-4.719,0-8.533,3.823-8.533,8.533S174.482,187.733,179.201,187.733z"/>
            <path d="M128.001,187.733h17.067c4.719,0,8.533-3.823,8.533-8.533s-3.814-8.533-8.533-8.533h-17.067
    					c-4.719,0-8.533,3.823-8.533,8.533S123.282,187.733,128.001,187.733z"/>
            <path d="M264.534,221.867h-85.333c-4.719,0-8.533,3.823-8.533,8.533s3.814,8.533,8.533,8.533h85.333
    					c4.719,0,8.533-3.823,8.533-8.533S269.253,221.867,264.534,221.867z"/>
            <path d="M128.001,102.4h136.533c4.719,0,8.533-3.823,8.533-8.533c0-4.71-3.814-8.533-8.533-8.533H128.001
    					c-4.719,0-8.533,3.823-8.533,8.533C119.468,98.577,123.282,102.4,128.001,102.4z"/>
          </g>
        </g>
      </g>
    </svg>
  ),
};
export const paymentIcon: Icon = {
  label: "payment",
  icon: (
    <svg fill="currentColor" width="800px" height="800px" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">

      <g data-name="21 payment" id="_21_payment">

        <path d="M29.38,9.97H9.81a2.006,2.006,0,0,0-2,2v4.47a2.006,2.006,0,0,0,2,2H29.38a2,2,0,0,0,2-2V11.97A2,2,0,0,0,29.38,9.97Zm0,6.47H9.81V11.97H29.38Z" />

        <path d="M10.97,21.83a3.16,3.16,0,1,0,3.16,3.16A3.167,3.167,0,0,0,10.97,21.83Zm0,4.32a1.16,1.16,0,1,1,1.16-1.16A1.161,1.161,0,0,1,10.97,26.15Z" />

        <path d="M19.6,21.83a3.16,3.16,0,1,0,3.15,3.16A3.167,3.167,0,0,0,19.6,21.83Zm0,4.32a1.16,1.16,0,1,1,1.15-1.16A1.161,1.161,0,0,1,19.6,26.15Z" />

        <path d="M28.23,21.83a3.16,3.16,0,1,0,3.15,3.16A3.16,3.16,0,0,0,28.23,21.83Zm0,4.32a1.16,1.16,0,1,1,1.15-1.16A1.161,1.161,0,0,1,28.23,26.15Z" />

        <path d="M10.97,30.46a3.155,3.155,0,1,0,3.16,3.16A3.167,3.167,0,0,0,10.97,30.46Zm0,4.31a1.155,1.155,0,1,1,1.16-1.15A1.159,1.159,0,0,1,10.97,34.77Z" />

        <path d="M19.6,30.46a3.155,3.155,0,1,0,3.15,3.16A3.167,3.167,0,0,0,19.6,30.46Zm0,4.31a1.155,1.155,0,1,1,1.15-1.15A1.159,1.159,0,0,1,19.6,34.77Z" />

        <path d="M28.23,30.46a3.155,3.155,0,1,0,3.15,3.16A3.16,3.16,0,0,0,28.23,30.46Zm0,4.31a1.155,1.155,0,1,1,1.15-1.15A1.159,1.159,0,0,1,28.23,34.77Z" />

        <path d="M10.97,39.09a3.155,3.155,0,1,0,3.16,3.16A3.16,3.16,0,0,0,10.97,39.09Zm0,4.31a1.155,1.155,0,1,1,1.16-1.15A1.159,1.159,0,0,1,10.97,43.4Z" />

        <path d="M19.6,39.09a3.155,3.155,0,1,0,3.15,3.16A3.16,3.16,0,0,0,19.6,39.09Zm0,4.31a1.155,1.155,0,1,1,1.15-1.15A1.159,1.159,0,0,1,19.6,43.4Z" />

        <path d="M10.97,47.72a3.155,3.155,0,1,0,3.16,3.15A3.158,3.158,0,0,0,10.97,47.72Zm0,4.31a1.155,1.155,0,1,1,1.16-1.16A1.161,1.161,0,0,1,10.97,52.03Z" />

        <path d="M19.6,47.72a3.155,3.155,0,1,0,3.15,3.15A3.158,3.158,0,0,0,19.6,47.72Zm0,4.31a1.155,1.155,0,1,1,0-2.31,1.155,1.155,0,0,1,0,2.31Z" />

        <path d="M29.38,39.09H27.07a2.006,2.006,0,0,0-2,2V52.03a2.006,2.006,0,0,0,2,2h2.31a2,2,0,0,0,2-2V41.09A2,2,0,0,0,29.38,39.09Zm0,12.94H27.07V41.09h2.31Z" />

        <path d="M56.26,11.05H35.7V9.58a5.008,5.008,0,0,0-5-5H8.5a5,5,0,0,0-5,5V54.42a5,5,0,0,0,5,5H30.7a5.008,5.008,0,0,0,5-5V52.95H56.26a4.24,4.24,0,0,0,4.24-4.23V15.28A4.24,4.24,0,0,0,56.26,11.05ZM33.7,54.42a3,3,0,0,1-3,3H8.5a3,3,0,0,1-3-3V9.58a3,3,0,0,1,3-3H30.7a3,3,0,0,1,3,3Zm6.47-3.47H35.7V13.05h4.47ZM58.5,48.72a2.234,2.234,0,0,1-2.24,2.23H42.17V13.05H56.26a2.234,2.234,0,0,1,2.24,2.23Z" />

        <path d="M56.19,36.31a5.855,5.855,0,0,0-11.71,0,5.768,5.768,0,0,0,1,3.24,5.737,5.737,0,0,0-1,3.23,5.855,5.855,0,1,0,11.71,0,5.737,5.737,0,0,0-1-3.23A5.768,5.768,0,0,0,56.19,36.31ZM50.33,46.64a3.86,3.86,0,0,1-3.85-3.86,3.722,3.722,0,0,1,.99-2.55v-.01l.01-.01a3.824,3.824,0,0,1,5.71,0v.01c.01,0,.01,0,.01.01a3.722,3.722,0,0,1,.99,2.55A3.862,3.862,0,0,1,50.33,46.64Zm3.44-8.59a4.889,4.889,0,0,0-.69-.42,1.618,1.618,0,0,0-.18-.1c-.24-.11-.49-.22-.75-.31a6.991,6.991,0,0,0-.79-.19l-.2-.03a5.69,5.69,0,0,0-.83-.07,5.554,5.554,0,0,0-.82.07l-.2.03a6.508,6.508,0,0,0-.79.19h-.01a7.038,7.038,0,0,0-.75.32.556.556,0,0,0-.17.09,4.285,4.285,0,0,0-.68.42h-.02a3.811,3.811,0,0,1-.41-1.74,3.855,3.855,0,0,1,7.71,0A3.819,3.819,0,0,1,53.77,38.05Z" />

      </g>

    </svg>
  ),
};
export const deletebinIcon: Icon = {
  label: "delete",
  icon: (
    <svg width="27" height="36" viewBox="0 0 27 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.7907 34.8233L25.5786 10.6613C25.6129 10.3644 25.3807 10.104 25.0819 10.104H2.49363C2.19478 10.104 1.96267 10.3644 1.99692 10.6613L4.78484 34.8233C4.81395 35.0756 5.02757 35.2659 5.28154 35.2659H22.294C22.5479 35.2659 22.7616 35.0756 22.7907 34.8233Z" fill="#5572D2" />
      <path d="M6.77148 12.7656L9.31187 32.3629M13.9088 12.7656V32.3629M20.8041 12.7656L18.3847 32.3629" stroke="#2934B2" stroke-width="1.5" stroke-linecap="round" />
      <g className="deletebin_cap">
        <path d="M9.77796 8.10584L9.77811 6.21542C9.77814 5.77361 10.1363 5.41548 10.5781 5.41548L16.1453 5.41545C16.5827 5.41545 16.939 5.76676 16.9452 6.20413L16.9731 8.17373" stroke="#6C75B7" />
        <path d="M1.20727 9.73846L1.20754 7.75278C1.20758 7.47667 1.43142 7.25286 1.70753 7.25285L25.7094 7.2524C25.9852 7.25239 26.2089 7.47564 26.2094 7.75139L26.2134 9.72493C26.2139 10.0014 25.9901 10.2258 25.7136 10.2259L1.70753 10.2385C1.43126 10.2387 1.20723 10.0147 1.20727 9.73846Z" fill="#919BDB" />
      </g>
    </svg>
  ),
};
export const checkIcon: Icon = {
  label: "check",
  icon: (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="7" cy="8" r="7" fill="currentColor" fill-opacity="0.75" />
      <path d="M3 7L6.21391 9.41043C6.65027 9.7377 7.26839 9.65492 7.60326 9.22437L14 1" stroke="white" stroke-width="1.2" stroke-linecap="round" />
    </svg>
  ),
};
export const checkarrowIcon: Icon = {
  label: "check",
  icon: (
    <svg width="31" height="21" viewBox="0 0 31 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 10.3248L10.7854 20L30 1" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  ),
};
export const arrowlineIcon: Icon = {
  label: "check",
  icon: (
    <svg width="228" height="78" viewBox="0 0 228 78" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M-0.00026834 19.7328C16.6723 3.36251 77.8611 -4.73742 116.542 3.58505C158.369 12.4865 179.911 24.9433 219.29 63.429C219.756 60.0931 219.845 57.3252 220.351 54.8783C220.81 52.0648 221.323 49.0955 222.409 46.5023C222.682 45.7234 224.587 44.8169 225.583 44.9916C226.579 45.1662 227.766 46.8073 227.807 47.6964C228.009 56.1652 227.896 64.5238 227.886 73.0934C227.797 75.8612 226.199 77.4002 223.257 77.243C212.181 76.1561 201.05 75.225 189.871 73.9273C187.353 73.5686 184.746 71.9543 181.607 70.8529C186.469 65.0354 191.846 67.7967 196.528 67.5149C201.421 67.1323 206.356 67.6388 212.505 67.6967C202.538 54.4023 191.267 44.3242 178.501 35.9959C131.816 5.2697 81.0127 -0.657346 27.5889 12.4414C20.6268 14.1978 13.917 16.7425 7.05715 18.7097C5.05737 18.8828 3.21452 19.1111 -0.00026834 19.7328Z" fill="black" />
    </svg>
  ),
};

export const connectToXeroIcon: Icon = {
  label: "check",
  icon: (
    <svg height="43" viewBox="0 0 190 43" width="190" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="a" x1="50%" x2="50%" y1="122.437977%" y2="7.040451%"><stop offset="0" stop-color="#0b789b" /><stop offset="1" stop-color="#0d84ab" /></linearGradient><path id="b" d="m61.7060001 20.656c0-3.568 2-5.536 4.592-5.536 1.904 0 3.12.848 3.76 2.48l-1.152.656c-.368-1.296-1.328-1.984-2.608-1.984-1.984 0-3.152 1.664-3.152 4.384s1.168 4.384 3.152 4.384c1.28 0 2.24-.704 2.608-1.984l1.152.64c-.64 1.648-1.856 2.496-3.76 2.496-2.592 0-4.592-1.968-4.592-5.536zm17.04 1.344c0 2.688-1.456 4.192-3.584 4.192s-3.584-1.504-3.584-4.192 1.456-4.192 3.584-4.192 3.584 1.504 3.584 4.192zm-1.328 0c0-2.064-.784-3.168-2.256-3.168s-2.256 1.104-2.256 3.168.784 3.168 2.256 3.168 2.256-1.104 2.256-3.168zm4.544-4 .16 1.552c.448-1.104 1.424-1.744 2.688-1.744 1.456 0 2.464.96 2.464 2.576v5.616h-1.312v-5.344c0-1.024-.496-1.696-1.568-1.696-1.136 0-2.096.656-2.096 2.4v4.64h-1.312v-8zm9.024 0 .16 1.552c.448-1.104 1.424-1.744 2.688-1.744 1.456 0 2.464.96 2.464 2.576v5.616h-1.312v-5.344c0-1.024-.496-1.696-1.568-1.696-1.136 0-2.096.656-2.096 2.4v4.64h-1.312v-8zm11.0399999 7.152c.96 0 1.648-.448 1.888-1.456l1.136.32c-.368 1.552-1.6 2.176-3.024 2.176-2.1919999 0-3.5679999-1.456-3.5679999-4.16 0-2.608 1.408-4.224 3.5679999-4.224 2 0 3.104 1.456 3.104 3.36 0 .464-.08.864-.16 1.072h-5.2479999c.064 1.792.8639999 2.912 2.3039999 2.912zm-2.2719999-3.872h4.0639999c.016-.144.016-.304.016-.416 0-1.12-.64-2.048-1.84-2.048-1.28 0-2.0639999.912-2.2399999 2.464zm7.1039999.72c0-2.624 1.408-4.192 3.568-4.192 1.632 0 2.768.992 2.928 2.448l-1.2.224c-.08-.88-.688-1.632-1.728-1.632-1.488 0-2.24 1.28-2.24 3.152s.752 3.152 2.24 3.152c1.04 0 1.648-.736 1.728-1.664l1.2.224c-.224 1.552-1.296 2.48-2.928 2.48-2.16 0-3.568-1.552-3.568-4.192zm12.544 2.672.24 1.04c-.464.288-1.088.48-1.648.48-1.488 0-2.384-.72-2.384-2.208v-4.976h-1.152v-1.008h1.152v-1.696l1.312-.208v1.904h2.4v1.008h-2.4v4.848c0 .88.48 1.232 1.168 1.232.528 0 .864-.128 1.312-.416zm10.128 0 .24 1.04c-.464.288-1.088.48-1.648.48-1.488 0-2.384-.72-2.384-2.208v-4.976h-1.152v-1.008h1.152v-1.696l1.312-.208v1.904h2.4v1.008h-2.4v4.848c0 .88.48 1.232 1.168 1.232.528 0 .864-.128 1.312-.416zm8.768-2.672c0 2.688-1.456 4.192-3.584 4.192s-3.584-1.504-3.584-4.192 1.456-4.192 3.584-4.192 3.584 1.504 3.584 4.192zm-1.328 0c0-2.064-.784-3.168-2.256-3.168s-2.256 1.104-2.256 3.168.784 3.168 2.256 3.168 2.256-1.104 2.256-3.168zm13.84 4-2.88-4.384h-.032l-2.896 4.384h-1.472l3.664-5.488-3.424-5.2h1.536l2.64 4.128h.032l2.656-4.128h1.488l-3.44 5.168 3.68 5.52zm6.192-.848c.96 0 1.648-.448 1.888-1.456l1.136.32c-.368 1.552-1.6 2.176-3.024 2.176-2.192 0-3.568-1.456-3.568-4.16 0-2.608 1.408-4.224 3.568-4.224 2 0 3.104 1.456 3.104 3.36 0 .464-.08.864-.16 1.072h-5.248c.064 1.792.864 2.912 2.304 2.912zm-2.272-3.872h4.064c.016-.144.016-.304.016-.416 0-1.12-.64-2.048-1.84-2.048-1.28 0-2.064.912-2.24 2.464zm11.824-3.424-.08 1.376c-.144-.032-.416-.048-.64-.048-1.264 0-2.192 1.024-2.192 2.768v4.048h-1.312v-8h1.04l.176 2.048c.32-1.424 1.52-2.464 3.008-2.192zm8.208 4.144c0 2.688-1.456 4.192-3.584 4.192s-3.584-1.504-3.584-4.192 1.456-4.192 3.584-4.192 3.584 1.504 3.584 4.192zm-1.328 0c0-2.064-.784-3.168-2.256-3.168s-2.256 1.104-2.256 3.168.784 3.168 2.256 3.168 2.256-1.104 2.256-3.168z" /></defs><g fill="none"><rect fill="url(#a)" height="43" rx="4" width="190" /><use fill="#000" xlinkHref="#b" /><use fill="#fff" xlinkHref="#b" /><g transform="translate(9 5)"><path d="m16.4995319 0c-9.11353873 0-16.4995319 7.38765603-16.4995319 16.5 0 9.1115118 7.38599317 16.5 16.4995319 16.5 9.110834 0 16.5004681-7.3884882 16.5004681-16.5 0-9.11234397-7.3896341-16.5-16.5004681-16.5" fill="#fff" /><path d="m16.8210417 13.1529405c-.5917606-.3667099-1.2823572-.5604607-1.9972182-.5604607-.7887004 0-1.5396445.2313595-2.1716716.669108-.9878365.6847018-1.5775054 1.8030753-1.5775054 2.9919777 0 .2984232.037861.5947061.1124324.8804911.3796556 1.4476786 1.6564696 2.5426103 3.1772881 2.7245384.1470512.0171227.2943115.0258878.4375975.0258878.3046657 0 .601069-.0378125.9057347-.1150682.396076-.0928496.7734306-.2491956 1.1219188-.4645536.329244-.2079178.6324455-.4880972.9513352-.8788603l.0209177-.0210976c.1061571-.1291332.1555228-.2951617.1353372-.4553807-.0180937-.1434021-.0884817-.2672355-.1980902-.3484661-.1039608-.0780711-.2277933-.1210816-.3485928-.1210816-.1177665 0-.2907555.0415836-.4472196.2403285l-.0122369.0158996c-.0516666.0671656-.1051112.1365735-.1666091.2054717-.2107455.230748-.452972.4208297-.719463.5648434-.3815381.1982353-.7937206.3002577-1.2242061.3033153-1.3523268-.0144727-2.180457-.8917023-2.5040532-1.7064547-.0508299-.1466635-.0871221-.2805871-.1104453-.4047262-.0004183-.0126381-.0013596-.0257859-.0021963-.0387298l5.2357952-.0009173c.3636535-.0075421.6683192-.1369811.8577286-.3643657.1714203-.2058794.2358467-.4751533.181147-.7590019-.2228777-1.0285815-.7961262-1.8525067-1.6577247-2.3826971zm-4.5758429 2.4481301c.2985996-1.1411018 1.350758-1.9376104 2.5596942-1.9376104 1.2152115 0 2.2624542.7944702 2.5623089 1.9376104zm13.6366416-.3005635c-.5269159 0-.9556233.4167528-.9556233.9289033 0 .5123543.4287074.9291071.9556233.9291071.52587 0 .9537408-.4167528.9537408-.9291071 0-.5121505-.4278708-.9289033-.9537408-.9289033zm-3.4273588-2.1263671c0-.2910849-.2441091-.5278462-.5434408-.5278462l-.1530127-.0021403c-.4644766 0-.9036429.1387138-1.2735718.4017705-.0708063-.2130138-.2779957-.362735-.511646-.362735-.3011097 0-.5384206.2300346-.5403032.5238713l.001778 6.0813915c.0019872.28976.2439.5254001.5394665.5254001.2973446 0 .5393619-.2357421.5393619-.5256039v-3.7400741c0-1.2117327.1070984-1.7182775 1.1844626-1.8481242.0893184-.0103959.1852259-.0110074.2095949-.0110074.3171118-.0112113.5473106-.2276904.5473106-.5149023zm-14.20832125 3.0552704 2.79407655-2.7315709c.1021828-.0977418.1585559-.2291173.1585559-.3698695 0-.2905753-.2436907-.5270308-.5431271-.5270308-.1449594 0-.2816563.0559543-.3847803.1573652l-2.7942858 2.7178117-2.80537212-2.7229077c-.10228736-.0981494-.2378338-.1522692-.3818519-.1522692-.29797208 0-.54030318.2364555-.54030318.5270308 0 .141058.05783733.2748796.16284399.3766981l2.79606375 2.7226019-2.79188022 2.7259653c-.10772595.1001879-.16702752.2347229-.16702752.3786346 0 .2904734.2423311.526929.54030318.526929.14182174 0 .27736819-.0538141.38206108-.1520654l2.80244365-2.7287172 2.79031139 2.7159771c.1069938.1071185.2459917.1661304.391474.1661304.2994364 0 .5431271-.2369651.5431271-.5282539 0-.1391214-.0562685-.2709046-.1583467-.3713982zm17.63568005-3.646715c-2.0639456 0-3.7431109 1.6359257-3.7431109 3.646715 0 2.0102796 1.6791653 3.6457977 3.7431109 3.6457977 2.0628997 0 3.7412283-1.6355181 3.7412283-3.6457977 0-2.0107893-1.6783286-3.646715-3.7412283-3.646715zm0 6.2017596c-1.4469792 0-2.6241206-1.1461978-2.6241206-2.5550446 0-1.4104776 1.1771414-2.5580004 2.6241206-2.5580004 1.4454104 0 2.6212967 1.1475228 2.6212967 2.5580004 0 1.4088468-1.1758863 2.5550446-2.6212967 2.5550446z" fill="#13b5ea" /></g></g></svg>
  ),
};


export const disconnectToXeroIcon: Icon = {
  label: "check",
  icon: (<svg height="43" viewBox="0 0 222 43" width="222" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="a" x1="50%" x2="50%" y1="122.437977%" y2="7.040451%"><stop offset="0" stop-color="#0b789b" /><stop offset="1" stop-color="#0d84ab" /></linearGradient><path id="b" d="m60.1160001 26v-10.688h3.184c3.008 0 5.28 1.616 5.28 5.312 0 3.68-2.272 5.376-5.28 5.376zm1.344-9.536v8.384h1.84c1.952 0 3.872-1.024 3.872-4.224 0-3.216-1.92-4.16-3.872-4.16zm10.928-.896c0 .544-.4.96-.944.96s-.944-.416-.944-.96.4-.96.944-.96.944.416.944.96zm-1.6 2.432h1.312v8h-1.312zm3.328 5.984 1.2-.336c.128.912.944 1.536 1.968 1.536 1.04 0 1.744-.416 1.744-1.264 0-2.112-4.56-.56-4.56-3.712 0-1.504 1.2-2.4 2.8-2.4 1.744 0 2.736.768 2.896 2.224l-1.232.176c-.08-.848-.608-1.392-1.664-1.392-.976 0-1.568.48-1.568 1.296 0 2.096 4.56.464 4.56 3.712 0 1.52-1.28 2.368-2.976 2.368-1.664 0-2.928-.8-3.168-2.208zm7.744-1.984c0-2.624 1.408-4.192 3.568-4.192 1.632 0 2.768.992 2.928 2.448l-1.2.224c-.08-.88-.688-1.632-1.728-1.632-1.488 0-2.24 1.28-2.24 3.152s.752 3.152 2.24 3.152c1.04 0 1.648-.736 1.728-1.664l1.2.224c-.224 1.552-1.296 2.48-2.928 2.48-2.16 0-3.568-1.552-3.568-4.192zm15.184 0c0 2.688-1.456 4.192-3.584 4.192s-3.584-1.504-3.584-4.192 1.456-4.192 3.584-4.192 3.584 1.504 3.584 4.192zm-1.328 0c0-2.064-.784-3.168-2.256-3.168s-2.256 1.104-2.256 3.168.784 3.168 2.256 3.168 2.256-1.104 2.256-3.168zm4.5439999-4 .16 1.552c.448-1.104 1.424-1.744 2.688-1.744 1.456 0 2.464.96 2.464 2.576v5.616h-1.312v-5.344c0-1.024-.496-1.696-1.568-1.696-1.136 0-2.096.656-2.096 2.4v4.64h-1.3119999v-8zm9.024 0 .16 1.552c.448-1.104 1.424-1.744 2.688-1.744 1.456 0 2.464.96 2.464 2.576v5.616h-1.312v-5.344c0-1.024-.496-1.696-1.568-1.696-1.136 0-2.096.656-2.096 2.4v4.64h-1.312v-8zm11.04 7.152c.96 0 1.648-.448 1.888-1.456l1.136.32c-.368 1.552-1.6 2.176-3.024 2.176-2.192 0-3.568-1.456-3.568-4.16 0-2.608 1.408-4.224 3.568-4.224 2 0 3.104 1.456 3.104 3.36 0 .464-.08.864-.16 1.072h-5.248c.064 1.792.864 2.912 2.304 2.912zm-2.272-3.872h4.064c.016-.144.016-.304.016-.416 0-1.12-.64-2.048-1.84-2.048-1.28 0-2.064.912-2.24 2.464zm7.104.72c0-2.624 1.408-4.192 3.568-4.192 1.632 0 2.768.992 2.928 2.448l-1.2.224c-.08-.88-.688-1.632-1.728-1.632-1.488 0-2.24 1.28-2.24 3.152s.752 3.152 2.24 3.152c1.04 0 1.648-.736 1.728-1.664l1.2.224c-.224 1.552-1.296 2.48-2.928 2.48-2.16 0-3.568-1.552-3.568-4.192zm12.544 2.672.24 1.04c-.464.288-1.088.48-1.648.48-1.488 0-2.384-.72-2.384-2.208v-4.976h-1.152v-1.008h1.152v-1.696l1.312-.208v1.904h2.4v1.008h-2.4v4.848c0 .88.48 1.232 1.168 1.232.528 0 .864-.128 1.312-.416zm6.416-5.664h-1.168v-1.008h1.168v-.912c0-1.744 1.168-2.832 2.704-2.832.576 0 1.04.144 1.472.368l-.304 1.104c-.352-.272-.64-.384-1.136-.384-.928 0-1.424.656-1.424 1.776v.88h2.048v1.008h-2.048v6.992h-1.312zm9.168-1.152-.08 1.376c-.144-.032-.416-.048-.64-.048-1.264 0-2.192 1.024-2.192 2.768v4.048h-1.312v-8h1.04l.176 2.048c.32-1.424 1.52-2.464 3.008-2.192zm8.208 4.144c0 2.688-1.456 4.192-3.584 4.192s-3.584-1.504-3.584-4.192 1.456-4.192 3.584-4.192 3.584 1.504 3.584 4.192zm-1.328 0c0-2.064-.784-3.168-2.256-3.168s-2.256 1.104-2.256 3.168.784 3.168 2.256 3.168 2.256-1.104 2.256-3.168zm9.472-2.512c.448-1.04 1.328-1.68 2.48-1.68 1.44 0 2.464.864 2.464 2.496v5.696h-1.312v-5.36c0-1.024-.432-1.68-1.552-1.68-.992 0-1.904.672-1.904 2.384v4.656h-1.312v-5.36c0-1.024-.448-1.68-1.552-1.68-1.008 0-1.904.688-1.904 2.4v4.64h-1.312v-8h.976l.16 1.552c.384-1.12 1.344-1.744 2.48-1.744s1.984.624 2.288 1.68zm17.952 6.512-2.88-4.384h-.032l-2.896 4.384h-1.472l3.664-5.488-3.424-5.2h1.536l2.64 4.128h.032l2.656-4.128h1.488l-3.44 5.168 3.68 5.52zm6.192-.848c.96 0 1.648-.448 1.888-1.456l1.136.32c-.368 1.552-1.6 2.176-3.024 2.176-2.192 0-3.568-1.456-3.568-4.16 0-2.608 1.408-4.224 3.568-4.224 2 0 3.104 1.456 3.104 3.36 0 .464-.08.864-.16 1.072h-5.248c.064 1.792.864 2.912 2.304 2.912zm-2.272-3.872h4.064c.016-.144.016-.304.016-.416 0-1.12-.64-2.048-1.84-2.048-1.28 0-2.064.912-2.24 2.464zm11.824-3.424-.08 1.376c-.144-.032-.416-.048-.64-.048-1.264 0-2.192 1.024-2.192 2.768v4.048h-1.312v-8h1.04l.176 2.048c.32-1.424 1.52-2.464 3.008-2.192zm8.208 4.144c0 2.688-1.456 4.192-3.584 4.192s-3.584-1.504-3.584-4.192 1.456-4.192 3.584-4.192 3.584 1.504 3.584 4.192zm-1.328 0c0-2.064-.784-3.168-2.256-3.168s-2.256 1.104-2.256 3.168.784 3.168 2.256 3.168 2.256-1.104 2.256-3.168z" /></defs><g fill="none"><rect fill="url(#a)" height="43" rx="4" width="222" /><use fill="#000" xlinkHref="#b" /><use fill="#fff" xlinkHref="#b" /><g transform="translate(9 5)"><path d="m16.4995319 0c-9.11353873 0-16.4995319 7.38765603-16.4995319 16.5 0 9.1115118 7.38599317 16.5 16.4995319 16.5 9.110834 0 16.5004681-7.3884882 16.5004681-16.5 0-9.11234397-7.3896341-16.5-16.5004681-16.5" fill="#fff" /><path d="m16.8210417 13.1529405c-.5917606-.3667099-1.2823572-.5604607-1.9972182-.5604607-.7887004 0-1.5396445.2313595-2.1716716.669108-.9878365.6847018-1.5775054 1.8030753-1.5775054 2.9919777 0 .2984232.037861.5947061.1124324.8804911.3796556 1.4476786 1.6564696 2.5426103 3.1772881 2.7245384.1470512.0171227.2943115.0258878.4375975.0258878.3046657 0 .601069-.0378125.9057347-.1150682.396076-.0928496.7734306-.2491956 1.1219188-.4645536.329244-.2079178.6324455-.4880972.9513352-.8788603l.0209177-.0210976c.1061571-.1291332.1555228-.2951617.1353372-.4553807-.0180937-.1434021-.0884817-.2672355-.1980902-.3484661-.1039608-.0780711-.2277933-.1210816-.3485928-.1210816-.1177665 0-.2907555.0415836-.4472196.2403285l-.0122369.0158996c-.0516666.0671656-.1051112.1365735-.1666091.2054717-.2107455.230748-.452972.4208297-.719463.5648434-.3815381.1982353-.7937206.3002577-1.2242061.3033153-1.3523268-.0144727-2.180457-.8917023-2.5040532-1.7064547-.0508299-.1466635-.0871221-.2805871-.1104453-.4047262-.0004183-.0126381-.0013596-.0257859-.0021963-.0387298l5.2357952-.0009173c.3636535-.0075421.6683192-.1369811.8577286-.3643657.1714203-.2058794.2358467-.4751533.181147-.7590019-.2228777-1.0285815-.7961262-1.8525067-1.6577247-2.3826971zm-4.5758429 2.4481301c.2985996-1.1411018 1.350758-1.9376104 2.5596942-1.9376104 1.2152115 0 2.2624542.7944702 2.5623089 1.9376104zm13.6366416-.3005635c-.5269159 0-.9556233.4167528-.9556233.9289033 0 .5123543.4287074.9291071.9556233.9291071.52587 0 .9537408-.4167528.9537408-.9291071 0-.5121505-.4278708-.9289033-.9537408-.9289033zm-3.4273588-2.1263671c0-.2910849-.2441091-.5278462-.5434408-.5278462l-.1530127-.0021403c-.4644766 0-.9036429.1387138-1.2735718.4017705-.0708063-.2130138-.2779957-.362735-.511646-.362735-.3011097 0-.5384206.2300346-.5403032.5238713l.001778 6.0813915c.0019872.28976.2439.5254001.5394665.5254001.2973446 0 .5393619-.2357421.5393619-.5256039v-3.7400741c0-1.2117327.1070984-1.7182775 1.1844626-1.8481242.0893184-.0103959.1852259-.0110074.2095949-.0110074.3171118-.0112113.5473106-.2276904.5473106-.5149023zm-14.20832125 3.0552704 2.79407655-2.7315709c.1021828-.0977418.1585559-.2291173.1585559-.3698695 0-.2905753-.2436907-.5270308-.5431271-.5270308-.1449594 0-.2816563.0559543-.3847803.1573652l-2.7942858 2.7178117-2.80537212-2.7229077c-.10228736-.0981494-.2378338-.1522692-.3818519-.1522692-.29797208 0-.54030318.2364555-.54030318.5270308 0 .141058.05783733.2748796.16284399.3766981l2.79606375 2.7226019-2.79188022 2.7259653c-.10772595.1001879-.16702752.2347229-.16702752.3786346 0 .2904734.2423311.526929.54030318.526929.14182174 0 .27736819-.0538141.38206108-.1520654l2.80244365-2.7287172 2.79031139 2.7159771c.1069938.1071185.2459917.1661304.391474.1661304.2994364 0 .5431271-.2369651.5431271-.5282539 0-.1391214-.0562685-.2709046-.1583467-.3713982zm17.63568005-3.646715c-2.0639456 0-3.7431109 1.6359257-3.7431109 3.646715 0 2.0102796 1.6791653 3.6457977 3.7431109 3.6457977 2.0628997 0 3.7412283-1.6355181 3.7412283-3.6457977 0-2.0107893-1.6783286-3.646715-3.7412283-3.646715zm0 6.2017596c-1.4469792 0-2.6241206-1.1461978-2.6241206-2.5550446 0-1.4104776 1.1771414-2.5580004 2.6241206-2.5580004 1.4454104 0 2.6212967 1.1475228 2.6212967 2.5580004 0 1.4088468-1.1758863 2.5550446-2.6212967 2.5550446z" fill="#13b5ea" /></g></g></svg>
  ),
};

export const connectToQboIcon: Icon = {
  label: "check",
  icon: (
    <svg width="223" height="36" viewBox="0 0 223 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="223" height="36" rx="4" fill="#2CA01C" />
      <path d="M35.3116 14.112C34.4156 12.928 32.6716 12.384 31.1996 12.384C27.7116 12.384 25.0556 14.672 25.0556 18.304C25.0556 21.84 27.5676 24.288 31.1036 24.288C33.0236 24.288 34.4956 23.552 35.4876 22.304L33.8716 21.168C33.2956 21.952 32.3356 22.48 31.1196 22.48C28.7836 22.48 27.2796 20.768 27.2796 18.304C27.2796 15.968 28.8636 14.16 31.1996 14.16C32.1116 14.16 33.1836 14.512 33.7756 15.328L35.3116 14.112ZM36.0087 20.128C36.0087 22.544 37.8647 24.224 40.1847 24.224C42.5047 24.224 44.3607 22.544 44.3607 20.128C44.3607 17.712 42.5047 16.096 40.1847 16.096C37.8647 16.096 36.0087 17.712 36.0087 20.128ZM37.9607 20.128C37.9607 18.928 38.6647 17.664 40.1847 17.664C41.7047 17.664 42.4087 18.928 42.4087 20.128C42.4087 21.328 41.7047 22.624 40.1847 22.624C38.6647 22.624 37.9607 21.328 37.9607 20.128ZM46.2223 24H48.1423V19.776C48.1423 18.752 48.7183 17.696 49.9343 17.696C51.1663 17.696 51.3743 18.832 51.3743 19.744V24H53.2943V19.2C53.2943 17.632 52.4623 16.096 50.4623 16.096C49.3263 16.096 48.4143 16.784 48.0783 17.552H48.0463V16.32H46.2223V24ZM55.5348 24H57.4548V19.776C57.4548 18.752 58.0308 17.696 59.2468 17.696C60.4788 17.696 60.6868 18.832 60.6868 19.744V24H62.6068V19.2C62.6068 17.632 61.7748 16.096 59.7748 16.096C58.6388 16.096 57.7268 16.784 57.3908 17.552H57.3588V16.32H55.5348V24ZM66.3193 19.392C66.3993 18.32 67.3113 17.536 68.4473 17.536C69.6953 17.536 70.2553 18.4 70.2553 19.392H66.3193ZM72.1753 20.256C72.1753 17.488 70.6073 16.096 68.4633 16.096C66.1433 16.096 64.3993 17.728 64.3993 20.208C64.3993 22.704 66.1593 24.224 68.5273 24.224C69.9833 24.224 71.0713 23.712 71.8233 22.688L70.5433 21.664C70.1113 22.272 69.4713 22.656 68.5113 22.656C67.3913 22.656 66.3993 21.856 66.3193 20.768H72.1593C72.1753 20.592 72.1753 20.432 72.1753 20.256ZM80.5948 17.296C79.9868 16.544 78.8188 16.096 77.6988 16.096C75.4428 16.096 73.5868 17.664 73.5868 20.16C73.5868 22.72 75.4748 24.224 77.7468 24.224C78.8828 24.224 79.9388 23.84 80.5788 23.152L79.3788 21.936C79.0108 22.384 78.3548 22.624 77.7628 22.624C76.3068 22.624 75.5868 21.36 75.5868 20.16C75.5868 18.96 76.2908 17.696 77.6988 17.696C78.3228 17.696 78.9788 18.016 79.2828 18.448L80.5948 17.296ZM82.0873 17.856V21.44C82.0873 22.912 82.5513 24.16 84.5833 24.16C85.0153 24.16 85.5273 24.08 85.8633 23.952L85.7993 22.448C85.5753 22.56 85.2393 22.608 84.9833 22.608C84.1353 22.608 83.9753 22.112 83.9753 21.424V17.856H85.8953V16.32H83.9753V14.096H82.0873V16.32H80.7433V17.856H82.0873ZM91.5248 17.856V21.44C91.5248 22.912 91.9888 24.16 94.0208 24.16C94.4528 24.16 94.9648 24.08 95.3008 23.952L95.2368 22.448C95.0128 22.56 94.6768 22.608 94.4208 22.608C93.5728 22.608 93.4128 22.112 93.4128 21.424V17.856H95.3328V16.32H93.4128V14.096H91.5248V16.32H90.1808V17.856H91.5248ZM96.2743 20.128C96.2743 22.544 98.1303 24.224 100.45 24.224C102.77 24.224 104.626 22.544 104.626 20.128C104.626 17.712 102.77 16.096 100.45 16.096C98.1303 16.096 96.2743 17.712 96.2743 20.128ZM98.2263 20.128C98.2263 18.928 98.9303 17.664 100.45 17.664C101.97 17.664 102.674 18.928 102.674 20.128C102.674 21.328 101.97 22.624 100.45 22.624C98.9303 22.624 98.2263 21.328 98.2263 20.128ZM122.792 22.368H119.992V22.336C121 21.616 122.008 20.224 122.008 18.192C122.008 14.752 119.464 12.384 115.992 12.384C112.52 12.384 109.928 14.752 109.928 18.192C109.928 21.872 112.344 24 115.96 24H122.792V22.368ZM115.992 14.192C118.28 14.192 119.816 15.888 119.816 18.192C119.816 20.608 118.2 22.24 115.96 22.24C113.688 22.24 112.136 20.608 112.136 18.192C112.136 15.888 113.8 14.192 115.992 14.192ZM131.121 16.32H129.201V20.544C129.201 21.568 128.625 22.624 127.409 22.624C126.177 22.624 125.969 21.488 125.969 20.576V16.32H124.049V21.12C124.049 22.688 124.881 24.224 126.881 24.224C128.017 24.224 128.929 23.536 129.265 22.768H129.297V24H131.121V16.32ZM133.457 24H135.377V16.32H133.457V24ZM133.185 13.712C133.185 14.32 133.697 14.864 134.401 14.864C135.105 14.864 135.649 14.368 135.649 13.712C135.649 13.056 135.105 12.56 134.401 12.56C133.697 12.56 133.185 13.104 133.185 13.712ZM144.267 17.296C143.659 16.544 142.491 16.096 141.371 16.096C139.115 16.096 137.259 17.664 137.259 20.16C137.259 22.72 139.147 24.224 141.419 24.224C142.555 24.224 143.611 23.84 144.251 23.152L143.051 21.936C142.683 22.384 142.027 22.624 141.435 22.624C139.979 22.624 139.259 21.36 139.259 20.16C139.259 18.96 139.963 17.696 141.371 17.696C141.995 17.696 142.651 18.016 142.955 18.448L144.267 17.296ZM145.551 24H147.471V20.064H147.519L150.559 24H153.103L149.567 19.792L152.895 16.32H150.431L147.519 19.552H147.471V11.904H145.551V24ZM154.303 24H158.383C160.527 24 162.671 23.168 162.671 20.704C162.671 19.184 161.647 18.224 160.223 18.032V18C161.391 17.648 162.191 16.8 162.191 15.52C162.191 13.456 160.431 12.672 158.719 12.672H154.303V24ZM156.319 14.336H157.935C159.455 14.336 160.175 14.736 160.175 15.744C160.175 16.72 159.455 17.28 158.111 17.28H156.319V14.336ZM156.319 19.008H158.207C159.839 19.008 160.655 19.424 160.655 20.608C160.655 22.096 159.167 22.304 158.127 22.304H156.319V19.008ZM164.118 20.128C164.118 22.544 165.974 24.224 168.294 24.224C170.614 24.224 172.47 22.544 172.47 20.128C172.47 17.712 170.614 16.096 168.294 16.096C165.974 16.096 164.118 17.712 164.118 20.128ZM166.07 20.128C166.07 18.928 166.774 17.664 168.294 17.664C169.814 17.664 170.518 18.928 170.518 20.128C170.518 21.328 169.814 22.624 168.294 22.624C166.774 22.624 166.07 21.328 166.07 20.128ZM173.884 20.128C173.884 22.544 175.74 24.224 178.06 24.224C180.38 24.224 182.236 22.544 182.236 20.128C182.236 17.712 180.38 16.096 178.06 16.096C175.74 16.096 173.884 17.712 173.884 20.128ZM175.836 20.128C175.836 18.928 176.54 17.664 178.06 17.664C179.58 17.664 180.284 18.928 180.284 20.128C180.284 21.328 179.58 22.624 178.06 22.624C176.54 22.624 175.836 21.328 175.836 20.128ZM184.129 24H186.049V20.064H186.097L189.137 24H191.681L188.145 19.792L191.473 16.32H189.009L186.097 19.552H186.049V11.904H184.129V24ZM198.147 17.264C197.523 16.48 196.371 16.096 195.267 16.096C193.747 16.096 192.211 16.832 192.211 18.544C192.211 19.984 193.347 20.448 194.483 20.72C195.651 20.992 196.243 21.184 196.243 21.824C196.243 22.512 195.571 22.736 195.011 22.736C194.179 22.736 193.459 22.32 193.043 21.776L191.779 22.96C192.515 23.776 193.747 24.224 194.931 24.224C196.611 24.224 198.131 23.536 198.131 21.664C198.131 20.16 196.787 19.648 195.651 19.376C194.579 19.12 193.987 18.96 193.987 18.368C193.987 17.76 194.611 17.536 195.219 17.536C195.923 17.536 196.563 17.92 196.899 18.368L198.147 17.264Z" fill="white" />
    </svg>
  ),
};
export const disconnectToQboIcon: Icon = {
  label: "check",
  icon: (
    <svg width="246" height="36" viewBox="0 0 246 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M241.587 0H4.41256C1.97557 0 0 1.79086 0 4V32C0 34.2091 1.97557 36 4.41256 36H241.587C244.024 36 246 34.2091 246 32V4C246 1.79086 244.024 0 241.587 0Z" fill="#2CA01C" />
      <path d="M56.7607 19.224C56.7607 21.64 58.6167 23.32 60.9367 23.32C63.2567 23.32 65.1127 21.64 65.1127 19.224C65.1127 16.808 63.2567 15.192 60.9367 15.192C58.6167 15.192 56.7607 16.808 56.7607 19.224ZM58.7127 19.224C58.7127 18.024 59.4167 16.76 60.9367 16.76C62.4567 16.76 63.1607 18.024 63.1607 19.224C63.1607 20.424 62.4567 21.72 60.9367 21.72C59.4167 21.72 58.7127 20.424 58.7127 19.224ZM66.9743 23.096H68.8943V18.872C68.8943 17.848 69.4703 16.792 70.6863 16.792C71.9183 16.792 72.1263 17.928 72.1263 18.84V23.096H74.0463V18.296C74.0463 16.728 73.2143 15.192 71.2143 15.192C70.0783 15.192 69.1663 15.88 68.8303 16.648H68.7983V15.416H66.9743V23.096ZM76.2868 23.096H78.2068V18.872C78.2068 17.848 78.7828 16.792 79.9988 16.792C81.2308 16.792 81.4388 17.928 81.4388 18.84V23.096H83.3588V18.296C83.3588 16.728 82.5268 15.192 80.5268 15.192C79.3908 15.192 78.4788 15.88 78.1428 16.648H78.1108V15.416H76.2868V23.096ZM87.0713 18.488C87.1513 17.416 88.0633 16.632 89.1993 16.632C90.4473 16.632 91.0073 17.496 91.0073 18.488H87.0713ZM92.9273 19.352C92.9273 16.584 91.3593 15.192 89.2153 15.192C86.8953 15.192 85.1513 16.824 85.1513 19.304C85.1513 21.8 86.9113 23.32 89.2793 23.32C90.7353 23.32 91.8233 22.808 92.5753 21.784L91.2953 20.76C90.8633 21.368 90.2233 21.752 89.2633 21.752C88.1433 21.752 87.1513 20.952 87.0713 19.864H92.9113C92.9273 19.688 92.9273 19.528 92.9273 19.352ZM101.347 16.392C100.739 15.64 99.5708 15.192 98.4508 15.192C96.1948 15.192 94.3388 16.76 94.3388 19.256C94.3388 21.816 96.2268 23.32 98.4988 23.32C99.6348 23.32 100.691 22.936 101.331 22.248L100.131 21.032C99.7628 21.48 99.1068 21.72 98.5148 21.72C97.0588 21.72 96.3388 20.456 96.3388 19.256C96.3388 18.056 97.0428 16.792 98.4508 16.792C99.0748 16.792 99.7308 17.112 100.035 17.544L101.347 16.392ZM102.839 16.952V20.536C102.839 22.008 103.303 23.256 105.335 23.256C105.767 23.256 106.279 23.176 106.615 23.048L106.551 21.544C106.327 21.656 105.991 21.704 105.735 21.704C104.887 21.704 104.727 21.208 104.727 20.52V16.952H106.647V15.416H104.727V13.192H102.839V15.416H101.495V16.952H102.839ZM112.277 16.952V20.536C112.277 22.008 112.741 23.256 114.773 23.256C115.205 23.256 115.717 23.176 116.053 23.048L115.989 21.544C115.765 21.656 115.429 21.704 115.173 21.704C114.325 21.704 114.165 21.208 114.165 20.52V16.952H116.085V15.416H114.165V13.192H112.277V15.416H110.933V16.952H112.277ZM117.026 19.224C117.026 21.64 118.882 23.32 121.202 23.32C123.522 23.32 125.378 21.64 125.378 19.224C125.378 16.808 123.522 15.192 121.202 15.192C118.882 15.192 117.026 16.808 117.026 19.224ZM118.978 19.224C118.978 18.024 119.682 16.76 121.202 16.76C122.722 16.76 123.426 18.024 123.426 19.224C123.426 20.424 122.722 21.72 121.202 21.72C119.682 21.72 118.978 20.424 118.978 19.224ZM143.544 21.464H140.744V21.432C141.752 20.712 142.76 19.32 142.76 17.288C142.76 13.848 140.216 11.48 136.744 11.48C133.272 11.48 130.68 13.848 130.68 17.288C130.68 20.968 133.096 23.096 136.712 23.096H143.544V21.464ZM136.744 13.288C139.032 13.288 140.568 14.984 140.568 17.288C140.568 19.704 138.952 21.336 136.712 21.336C134.44 21.336 132.888 19.704 132.888 17.288C132.888 14.984 134.552 13.288 136.744 13.288ZM151.873 15.416H149.953V19.64C149.953 20.664 149.377 21.72 148.161 21.72C146.929 21.72 146.721 20.584 146.721 19.672V15.416H144.801V20.216C144.801 21.784 145.633 23.32 147.633 23.32C148.769 23.32 149.681 22.632 150.017 21.864H150.049V23.096H151.873V15.416ZM154.209 23.096H156.129V15.416H154.209V23.096ZM153.937 12.808C153.937 13.416 154.449 13.96 155.153 13.96C155.857 13.96 156.401 13.464 156.401 12.808C156.401 12.152 155.857 11.656 155.153 11.656C154.449 11.656 153.937 12.2 153.937 12.808ZM165.019 16.392C164.411 15.64 163.243 15.192 162.123 15.192C159.867 15.192 158.011 16.76 158.011 19.256C158.011 21.816 159.899 23.32 162.171 23.32C163.307 23.32 164.363 22.936 165.003 22.248L163.803 21.032C163.435 21.48 162.779 21.72 162.187 21.72C160.731 21.72 160.011 20.456 160.011 19.256C160.011 18.056 160.715 16.792 162.123 16.792C162.747 16.792 163.403 17.112 163.707 17.544L165.019 16.392ZM166.303 23.096H168.223V19.16H168.271L171.311 23.096H173.855L170.319 18.888L173.647 15.416H171.183L168.271 18.648H168.223V11H166.303V23.096ZM175.055 23.096H179.135C181.279 23.096 183.423 22.264 183.423 19.8C183.423 18.28 182.399 17.32 180.975 17.128V17.096C182.143 16.744 182.943 15.896 182.943 14.616C182.943 12.552 181.183 11.768 179.471 11.768H175.055V23.096ZM177.071 13.432H178.687C180.207 13.432 180.927 13.832 180.927 14.84C180.927 15.816 180.207 16.376 178.863 16.376H177.071V13.432ZM177.071 18.104H178.959C180.591 18.104 181.407 18.52 181.407 19.704C181.407 21.192 179.919 21.4 178.879 21.4H177.071V18.104ZM184.87 19.224C184.87 21.64 186.726 23.32 189.046 23.32C191.366 23.32 193.222 21.64 193.222 19.224C193.222 16.808 191.366 15.192 189.046 15.192C186.726 15.192 184.87 16.808 184.87 19.224ZM186.822 19.224C186.822 18.024 187.526 16.76 189.046 16.76C190.566 16.76 191.27 18.024 191.27 19.224C191.27 20.424 190.566 21.72 189.046 21.72C187.526 21.72 186.822 20.424 186.822 19.224ZM194.636 19.224C194.636 21.64 196.492 23.32 198.812 23.32C201.132 23.32 202.988 21.64 202.988 19.224C202.988 16.808 201.132 15.192 198.812 15.192C196.492 15.192 194.636 16.808 194.636 19.224ZM196.588 19.224C196.588 18.024 197.292 16.76 198.812 16.76C200.332 16.76 201.036 18.024 201.036 19.224C201.036 20.424 200.332 21.72 198.812 21.72C197.292 21.72 196.588 20.424 196.588 19.224ZM204.881 23.096H206.801V19.16H206.849L209.889 23.096H212.433L208.897 18.888L212.225 15.416H209.761L206.849 18.648H206.801V11H204.881V23.096ZM218.899 16.36C218.275 15.576 217.123 15.192 216.019 15.192C214.499 15.192 212.963 15.928 212.963 17.64C212.963 19.08 214.099 19.544 215.235 19.816C216.403 20.088 216.995 20.28 216.995 20.92C216.995 21.608 216.323 21.832 215.763 21.832C214.931 21.832 214.211 21.416 213.795 20.872L212.531 22.056C213.267 22.872 214.499 23.32 215.683 23.32C217.363 23.32 218.883 22.632 218.883 20.76C218.883 19.256 217.539 18.744 216.403 18.472C215.331 18.216 214.739 18.056 214.739 17.464C214.739 16.856 215.363 16.632 215.971 16.632C216.675 16.632 217.315 17.016 217.651 17.464L218.899 16.36Z" fill="white" />
      <path d="M56.0734 16.3914L54.7614 17.5434C54.4574 17.1114 53.8014 16.7914 53.1774 16.7914C51.7694 16.7914 51.0654 18.0554 51.0654 19.2554C51.0654 20.4554 51.7854 21.7194 53.2414 21.7194C53.8334 21.7194 54.4894 21.4794 54.8574 21.0314L56.0574 22.2474C55.4174 22.9354 54.3614 23.3194 53.2254 23.3194C50.9534 23.3194 49.0654 21.8154 49.0654 19.2554C49.0654 16.7594 50.9214 15.1914 53.1774 15.1914C54.2974 15.1914 55.4654 15.6394 56.0734 16.3914Z" fill="white" />
      <path d="M47.8599 16.3594L46.6119 17.4634C46.2759 17.0154 45.6359 16.6314 44.9319 16.6314C44.3239 16.6314 43.6999 16.8554 43.6999 17.4634C43.6999 18.0554 44.2919 18.2154 45.3639 18.4714C46.4999 18.7434 47.8439 19.2554 47.8439 20.7594C47.8439 22.6314 46.3239 23.3194 44.6439 23.3194C43.4599 23.3194 42.2279 22.8714 41.4919 22.0554L42.7559 20.8714C43.1719 21.4154 43.8919 21.8314 44.7239 21.8314C45.2839 21.8314 45.9559 21.6074 45.9559 20.9194C45.9559 20.2794 45.3639 20.0874 44.1959 19.8154C43.0599 19.5434 41.9239 19.0794 41.9239 17.6394C41.9239 15.9274 43.4599 15.1914 44.9799 15.1914C46.0839 15.1914 47.2359 15.5754 47.8599 16.3594Z" fill="white" />
      <path d="M38.1548 23.0963V15.4163H40.0748V23.0963H38.1548ZM37.8828 12.8083C37.8828 12.2002 38.3948 11.6562 39.0988 11.6562C39.8028 11.6562 40.3468 12.1523 40.3468 12.8083C40.3468 13.4642 39.8028 13.9602 39.0988 13.9602C38.3948 13.9602 37.8828 13.4163 37.8828 12.8083Z" fill="white" />
      <path d="M26 23.0956V11.7676H30.016C32.976 11.7676 36.272 13.1756 36.272 17.4316C36.272 21.3996 32.976 23.0956 30.016 23.0956H26ZM28.016 21.3356H29.696C31.776 21.3356 34.112 20.4876 34.112 17.4316C34.112 14.1836 31.776 13.4956 29.696 13.4956H28.016V21.3356Z" fill="white" />
    </svg>

  ),
};



export const call: Icon = {
  label: "call",
  icon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44C20.55 20.98 20.01 21.37 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.3 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" />
      <path d="M18.5 9C18.5 8.4 18.03 7.48 17.33 6.73C16.69 6.04 15.84 5.5 15 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M22 9C22 5.13 18.87 2 15 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  ),
};

export const location: Icon = {
  label: "location",
  icon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.9999 13.4299C13.723 13.4299 15.1199 12.0331 15.1199 10.3099C15.1199 8.58681 13.723 7.18994 11.9999 7.18994C10.2768 7.18994 8.87988 8.58681 8.87988 10.3099C8.87988 12.0331 10.2768 13.4299 11.9999 13.4299Z" stroke="currentColor" stroke-width="1.7" />
      <path d="M3.6202 8.49C5.5902 -0.169998 18.4202 -0.159997 20.3802 8.5C21.5302 13.58 18.3702 17.88 15.6002 20.54C13.5902 22.48 10.4102 22.48 8.3902 20.54C5.6302 17.88 2.4702 13.57 3.6202 8.49Z" stroke="currentColor" stroke-width="1.7" />
    </svg>
  ),
};


export const desktopIcon: Icon = {
  label: "desktopIcon",
  icon: (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.44 1H16.55C20.11 1 21 1.89 21 5.44V11.77C21 15.33 20.11 16.21 16.56 16.21H5.44C1.89 16.22 1 15.33 1 11.78V5.44C1 1.89 1.89 1 5.44 1Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11 16.22V21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M1 12H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6.5 21H15.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  ),
};